
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3AQ56", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6bix3")).SidebarUser);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $6bix3 = parcelRequire("6bix3");

});
parcelRegister("6bix3", function(module, exports) {

$parcel$export(module.exports, "SidebarUser", () => $6e904a4c765f3eed$export$582f0f2228491d32);

var $5uXOq = parcelRequire("5uXOq");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $lGo7j = parcelRequire("lGo7j");

var $aM9Kr = parcelRequire("aM9Kr");

var $04vn8 = parcelRequire("04vn8");
const $6e904a4c765f3eed$export$582f0f2228491d32 = ()=>{
    const { data: features, loading: loading } = (0, $aM9Kr.useFeatures)();
    if (loading || !features) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $04vn8.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).USER
    }));
};

});
parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("aM9Kr", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $d3b2e607e04b3480$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $gpXo6 = parcelRequire("gpXo6");
const $d3b2e607e04b3480$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data ? {
            hasBacklog: data.hasBacklog,
            hasBoard: data.hasBoard,
            hasReports: data.hasReports
        } : null, [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("gpXo6", function(module, exports) {

$parcel$export(module.exports, "useJiraUserBoardNavigationResource", () => $c3c49f06ba708347$export$517acde8347261e3);

var $7xTO3 = parcelRequire("7xTO3");

var $2YP9W = parcelRequire("2YP9W");
const $c3c49f06ba708347$export$517acde8347261e3 = ()=>(0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));

});


parcelRegister("04vn8", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $3b93c286f1544afe$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $g9uZe = parcelRequire("g9uZe");

var $QasRB = parcelRequire("QasRB");

var $v8Zna = parcelRequire("v8Zna");

var $bZNwM = parcelRequire("bZNwM");

var $g2EiV = parcelRequire("g2EiV");
var $9btdk = parcelRequire("9btdk");
var $gjTBi = parcelRequire("gjTBi");
var $gZEU1 = parcelRequire("gZEU1");
var $bWqXX = parcelRequire("bWqXX");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fNi03 = parcelRequire("fNi03");

var $juTur = parcelRequire("juTur");

var $kZj7F = parcelRequire("kZj7F");

var $l468O = parcelRequire("l468O");

var $7EMGV = parcelRequire("7EMGV");

var $3SzZi = parcelRequire("3SzZi");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $6jY6G = parcelRequire("6jY6G");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");


var $lUN4t = parcelRequire("lUN4t");

var $aM9Kr = parcelRequire("aM9Kr");

var $l0NCV = parcelRequire("l0NCV");

var $b0U9q = parcelRequire("b0U9q");

var $2f44y = parcelRequire("2f44y");
const $3b93c286f1544afe$var$useThrowAvatarDI = (0, $7OqB4.withThrowOnError)((0, $lUN4t.useAvatar));
const $3b93c286f1544afe$var$useThrowFeaturesDI = (0, $7OqB4.withThrowOnError)((0, $aM9Kr.useFeatures));
const $3b93c286f1544afe$var$useThrowBoardDI = (0, $7OqB4.withThrowOnError)((0, $fNi03.useBoard));
const $3b93c286f1544afe$export$d9b273488cd8ce6f = ({ BoardIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
BoardIcon = (0, (/*@__PURE__*/$parcel$interopDefault($v8Zna))), ContextualAnalyticsData: ContextualAnalyticsData = (0, $juTur.ContextualAnalyticsData), LeftArrow: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
LeftArrow = (0, (/*@__PURE__*/$parcel$interopDefault($g9uZe))), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), NavigationHeader: NavigationHeader = (0, $g2EiV.default), NestableNavigationContent: NestableNavigationContent = (0, $9btdk.default), NestingMenuItem: // @ts-expect-error - TS2339 - Property 'NestingMenuItem' does not exist on type 'MenuProps'.
NestingMenuItem = (0, $kZj7F.NestingMenuItem), ProjectHeader: ProjectHeader = (0, $l468O.ProjectHeader), Reports: Reports = (0, $b0U9q.Reports), ScopeSwitcher: ScopeSwitcher = (0, $7EMGV.ScopeSwitcher), Section: Section = (0, $gjTBi.default), SkeletonItem: SkeletonItem = (0, $bWqXX.default), SideNavigation: SideNavigation = (0, $gZEU1.default), useAvatar: useAvatar = $3b93c286f1544afe$var$useThrowAvatarDI, useBoard: useBoard = $3b93c286f1544afe$var$useThrowBoardDI, useCurrentRoute: // @ts-expect-error - TS2339 - Property 'useCurrentRoute' does not exist on type 'MenuProps'.
useCurrentRoute = (0, $6jY6G.useCurrentRoute), useFeatures: useFeatures = $3b93c286f1544afe$var$useThrowFeaturesDI, useIntl: useIntl = (0, $koVbs.default), usePathParam: // @ts-expect-error - TS2339 - Property 'usePathParam' does not exist on type 'MenuProps'.
usePathParam = (0, $bmKPg.usePathParam), useQueryParam: // @ts-expect-error - TS2339 - Property 'useQueryParam' does not exist on type 'MenuProps'.
useQueryParam = (0, $ieDtd.useQueryParam), matchUrlPathname: matchUrlPathname = (0, $4OCke.matchUrlPathname) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const route = useCurrentRoute();
    const [paramAccountId] = usePathParam('accountId');
    const [isLocationlessBoard] = useQueryParam('locationless');
    const { data: avatar } = useAvatar();
    const { data: features } = useFeatures();
    const { data: board } = useBoard();
    const [stack, setStack] = (0, $5uXOq.useState)((0, $2f44y.calculateStack)(route));
    (0, $5uXOq.useEffect)(()=>{
        setStack((0, $2f44y.calculateStack)(route));
    }, [
        route
    ]);
    if (avatar == null || board == null || features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    const shouldUsePrettyUrl = !isLocationlessBoard;
    const boardAccountId = paramAccountId ?? '';
    const BackMenuItem = {
        href: shouldUsePrettyUrl ? `/jira/people/${boardAccountId}/boards/${board.id}` : `/secure/RapidBoard.jspa?rapidView=${board.id}&locationless=true`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LeftArrow, {
            label: ""
        }),
        // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
        onClick: (event)=>event.preventDefault(),
        title: formatMessage((0, $l0NCV.default).itemBack)
    };
    // Adding a small function to handle the rendering of the reports menu item because for UIF
    // we need an actual anchor tag to completely refresh the page due to some issues around
    // the company managed report pages (which are part of the legacy FE).
    const renderReportsLink = ()=>{
        // Early termination. No reports feature means no link.
        if (!(0, $3SzZi.shouldRenderNesting)(features.hasReports, stack, 'reports')) return null;
        const oldReportsHref = shouldUsePrettyUrl ? `/jira/people/${boardAccountId}/boards/${board.id}/reports/burndown-chart` : `/secure/RapidBoard.jspa?rapidView=${board.id}&view=reporting&locationless=true`;
        const reportsHref = `/jira/people/${boardAccountId}/boards/${board.id}/reports`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NestingMenuItem, {
            reloadOnNavigationToNesting: true,
            analytics: {
                itemId: 'reports'
            },
            href: (0, $4R6GH.fg)('reports-overview-page-migration') ? reportsHref : oldReportsHref,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
                spacing: "spacious",
                label: ""
            }),
            id: "reports",
            overrides: {
                BackMenuItem: BackMenuItem
            },
            title: formatMessage((0, $l0NCV.default).itemReports),
            selectedOn: (0, $4R6GH.fg)('reports-overview-page-migration') ? matchUrlPathname() : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Reports, {
            enableKeyboardShortcuts: true
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContextualAnalyticsData, {
        menuId: (0, $2abca4e721f0f565$export$d4cd258d01c03112),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SideNavigation, {
        label: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NavigationHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectHeader, {
        description: formatMessage((0, $l0NCV.default).headerDescription),
        avatarUrl: avatar.url ?? '',
        name: avatar.name ?? ''
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NestableNavigationContent, {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ScopeSwitcher, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, features.hasBacklog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: `backlog-${board.type}`
        },
        href: shouldUsePrettyUrl ? `/jira/people/${boardAccountId}/boards/${board.id}/backlog` : `/secure/RapidBoard.jspa?rapidView=${board.id}&view=planning&locationless=true`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
            spacing: "spacious",
            label: ""
        }),
        selectedOn: shouldUsePrettyUrl ? matchUrlPathname() : (0, $2f44y.backlogSelected)
    }, formatMessage((0, $l0NCV.default).backlog)), features.hasBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: `board-${board.type}`
        },
        href: shouldUsePrettyUrl ? `/jira/people/${boardAccountId}/boards/${board.id}` : `/secure/RapidBoard.jspa?rapidView=${board.id}&locationless=true`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardIcon, {
            label: ""
        }),
        selectedOn: shouldUsePrettyUrl ? matchUrlPathname() : (0, $2f44y.boardSelected)
    }, formatMessage(board.type === (0, $976eff6d67d3515b$export$4498412e32a31fb6) ? (0, $l0NCV.default).scrumBoard : (0, $l0NCV.default).kanbanBoard)), renderReportsLink()))));
};

});
parcelRegister("g9uZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $bc2585eb44f99538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $bc2585eb44f99538$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $bc2585eb44f99538$var$_arrowLeft.default
    }));
$bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;

});
parcelRegister("ctqwA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $914cc4b222e651e0$var$_react = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $914cc4b222e651e0$var$_baseNew = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $914cc4b222e651e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $914cc4b222e651e0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $914cc4b222e651e0$var$_react.default.createElement($914cc4b222e651e0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$914cc4b222e651e0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $914cc4b222e651e0$var$_default = module.exports.default = $914cc4b222e651e0$var$ArrowLeftIcon;

});


parcelRegister("bZNwM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bbbcf5ce8764439$var$_react = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bbbcf5ce8764439$var$_chartTrend = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("7EZ5v")));

var $8bbbcf5ce8764439$var$_graphLine = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("gSPJV")));
function $8bbbcf5ce8764439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bbbcf5ce8764439$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $8bbbcf5ce8764439$var$_react.default.createElement($8bbbcf5ce8764439$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $8bbbcf5ce8764439$var$_graphLine.default
    }, props));
$8bbbcf5ce8764439$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $8bbbcf5ce8764439$var$_default = module.exports.default = $8bbbcf5ce8764439$var$ChartTrendIcon;

});
parcelRegister("gSPJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a9d2eb82ff139c$var$_react = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c4a9d2eb82ff139c$var$_chartTrend = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("7EZ5v")));
function $c4a9d2eb82ff139c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4a9d2eb82ff139c$var$GraphLineIcon = (props)=>/*#__PURE__*/ $c4a9d2eb82ff139c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $c4a9d2eb82ff139c$var$_chartTrend.default
    }));
$c4a9d2eb82ff139c$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $c4a9d2eb82ff139c$var$_default = module.exports.default = $c4a9d2eb82ff139c$var$GraphLineIcon;

});


parcelRegister("g2EiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d4c6f37fa43791$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $f8d4c6f37fa43791$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $f8d4c6f37fa43791$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $f8d4c6f37fa43791$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $f8d4c6f37fa43791$export$2e2bcd8739ae039 = $f8d4c6f37fa43791$var$NavigationHeader;

});

parcelRegister("9btdk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $1598986e4d07c239$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $1598986e4d07c239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $VSDnB = parcelRequire("VSDnB");

var $6XySk = parcelRequire("6XySk");

var $8UO8z = parcelRequire("8UO8z");

var $9zCCP = parcelRequire("9zCCP");

var $j9VTE = parcelRequire("j9VTE");

var $cfT4M = parcelRequire("cfT4M");
const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $1598986e4d07c239$var$nestableNavigationContentStyles = null;
const $1598986e4d07c239$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6XySk.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $9zCCP.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfT4M.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j9VTE.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UO8z.default), {
                                    title: "",
                                    id: $1598986e4d07c239$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;

});
parcelRegister("6XySk", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf862f964b3fe45$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2gYe = parcelRequire("d2gYe");


var $ayWDM = parcelRequire("ayWDM");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $acf862f964b3fe45$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;

});
parcelRegister("d2gYe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
    }, props));
$97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;

});

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("ayWDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $860cc941614c9e62$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $jsTfk = parcelRequire("jsTfk");

var $j9VTE = parcelRequire("j9VTE");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $860cc941614c9e62$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jsTfk.overrideStyleFunction)((0, $jsTfk.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;

});


parcelRegister("8UO8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0599b2a9b08db47e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bh9nY = parcelRequire("bh9nY");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $ayWDM = parcelRequire("ayWDM");
var $jSfqD = parcelRequire("jSfqD");
var $kzjuk = parcelRequire("kzjuk");

var $9btdk = parcelRequire("9btdk");

var $j9VTE = parcelRequire("j9VTE");

var $9zCCP = parcelRequire("9zCCP");
const $0599b2a9b08db47e$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $0599b2a9b08db47e$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $j9VTE.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $9zCCP.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j9VTE.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kzjuk.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $9btdk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "data-right-arrow": true,
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh9nY))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;

});
parcelRegister("bh9nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
function $835890081946c47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835890081946c47e$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
    }, props));
$835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("1zw66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $1251f532550be707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $1251f532550be707$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $1251f532550be707$var$_arrowRight.default
    }));
$1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;

});


parcelRegister("jSfqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e63733262ea805c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1aogK = parcelRequire("1aogK");

var $jsTfk = parcelRequire("jsTfk");

var $j9VTE = parcelRequire("j9VTE");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $0e63733262ea805c$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jsTfk.overrideStyleFunction)((0, $jsTfk.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;

});

parcelRegister("kzjuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf97ddffeccb81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cw1vL = parcelRequire("cw1vL");

var $j9VTE = parcelRequire("j9VTE");
const $dfdf97ddffeccb81$var$outerContainerCSS = null;
const $dfdf97ddffeccb81$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $dfdf97ddffeccb81$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $dfdf97ddffeccb81$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    const scrollbar = (0, $cw1vL.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $dfdf97ddffeccb81$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $dfdf97ddffeccb81$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $dfdf97ddffeccb81$var$containerCSS.basic,
                    showTopScrollIndicator && $dfdf97ddffeccb81$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;

});
parcelRegister("cw1vL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03f8a420074f68d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a03f8a420074f68d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("9zCCP", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $edc749a9b64f215e$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $edc749a9b64f215e$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $9btdk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});


parcelRegister("cfT4M", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $0051a7791f96d83a$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Sbj3 = parcelRequire("8Sbj3");
const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("gZEU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2dd47d2fa741f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7LBE = parcelRequire("j7LBE");
const $eb2dd47d2fa741f7$var$sidebarMinWidth = '240px';
const $eb2dd47d2fa741f7$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $eb2dd47d2fa741f7$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $eb2dd47d2fa741f7$export$2e2bcd8739ae039 = $eb2dd47d2fa741f7$var$SideNavigation;

});

// Backend types
const $976eff6d67d3515b$export$9a958daafd9a03ed = 'agility-board';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $976eff6d67d3515b$var$CORE_BOARD = 'core-board';
const $976eff6d67d3515b$export$b4e9cdb19cfa0abb = 'kanban';
const $976eff6d67d3515b$export$4498412e32a31fb6 = 'scrum';

parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $jSfqD = parcelRequire("jSfqD");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("fNi03", function(module, exports) {

$parcel$export(module.exports, "useBoard", () => $860e4a990aab148d$export$15adc93832970b54);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $gpXo6 = parcelRequire("gpXo6");

var $1J3t1 = parcelRequire("1J3t1");

var $6VnTH = parcelRequire("6VnTH");
const $860e4a990aab148d$var$USER_BOARD_ROUTE_NAMES = [
    'rapidboard-user-board',
    'rapidboard-user-backlog',
    'rapidboard-user-report',
    'rapidboard-user-board-settings',
    'rapidboard-user-reports-overview',
    'software-reports-velocity-user-board'
];
const $860e4a990aab148d$var$isOnUserBoardRoute = (routeName)=>$860e4a990aab148d$var$USER_BOARD_ROUTE_NAMES.includes(routeName);
const $860e4a990aab148d$var$isOnLocationLessBoardRoute = (match, query)=>{
    const { locationless: locationless = 'false' } = query;
    return match.url.includes('RapidBoard.jspa') && JSON.parse(locationless) === true;
};
const $860e4a990aab148d$export$50230c720b1c453e = ()=>{
    const [{ match: match, route: route, query: query }] = (0, $doZTA.useRouter)();
    return $860e4a990aab148d$var$isOnUserBoardRoute(route.name) || $860e4a990aab148d$var$isOnLocationLessBoardRoute(match, query);
};
const $860e4a990aab148d$export$15adc93832970b54 = ()=>{
    const isOnUserOrLocationlessBoardRoute = $860e4a990aab148d$export$50230c720b1c453e();
    // pb -> project board
    const { data: pb, loading: pbLoading, error: pbError } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    // ub -> user board
    const { data: ub, loading: ubLoading, error: ubError } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    const projectBoard = (0, $5uXOq.useMemo)(()=>pb && (0, $6VnTH.extractData)(pb), [
        pb
    ]);
    const userBoard = (0, $5uXOq.useMemo)(()=>ub && (0, $6VnTH.extractUserBoard)(ub), [
        ub
    ]);
    if (isOnUserOrLocationlessBoardRoute) return {
        data: userBoard,
        loading: ubLoading,
        error: ubError
    };
    return {
        data: projectBoard,
        loading: pbLoading,
        error: pbError
    };
};

});
parcelRegister("6VnTH", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4d73b10ca351bbb3$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $4d73b10ca351bbb3$export$67db9e2d1b6ed865);
const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $lpwtK.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d2gYe = parcelRequire("d2gYe");

var $8UO8z = parcelRequire("8UO8z");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fpoBX = parcelRequire("fpoBX");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $2fbfde7c900477f4$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _btpd1ady _vl7qglyw _slhpglyw _7upw1txw"
};
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement(WrapperComponent, null, /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$2fbfde7c900477f4$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $bwpsq.default)([
                iconSecondaryColor && $2fbfde7c900477f4$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $8UO8z.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $bwpsq.default)([
                $2fbfde7c900477f4$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("kavsL", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $e059487e30c8155a$export$729f3684d5c2b9b9);
const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});


parcelRegister("l468O", function(module, exports) {

$parcel$export(module.exports, "ProjectHeader", () => $3b1d5cf2181bf590$export$69277e177204bdfd);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $fJoTF = parcelRequire("fJoTF");
const $3b1d5cf2181bf590$export$69277e177204bdfd = ({ Avatar: Avatar = (0, $ujWmd.default), Header: Header = (0, $fJoTF.CustomHeader), avatarUrl: avatarUrl, iconBefore: iconBefore, description: description, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
        description: description,
        iconBefore: iconBefore ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: avatarUrl ? `${avatarUrl}?size=xxlarge` : avatarUrl
        })
    }, name);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jSfqD = parcelRequire("jSfqD");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_vrjt140y _1cmdleuv _1w901jnk _14n4h2mm _1cg71wug _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_16hg1im0",
            item?.color?.default && "_1w901jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: title, ...props })=>/*#__PURE__*/ $5uXOq.createElement("h2", props, title)
            }
        }
    }, children);
};

});


parcelRegister("7EMGV", function(module, exports) {

$parcel$export(module.exports, "ScopeSwitcher", () => $055543892c96669f$export$8d2db9c1a2d8e427);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7c1AG = parcelRequire("7c1AG");

var $juVrZ = parcelRequire("juVrZ");
var $j9VTE = parcelRequire("j9VTE");

var $1ADgn = parcelRequire("1ADgn");

var $koVbs = parcelRequire("koVbs");

var $3zdOn = parcelRequire("3zdOn");

var $cYlk7 = parcelRequire("cYlk7");

var $4DPZY = parcelRequire("4DPZY");

var $cZpsT = parcelRequire("cZpsT");

var $lVJAU = parcelRequire("lVJAU");

var $fNi03 = parcelRequire("fNi03");

var $bdAP2 = parcelRequire("bdAP2");
const $055543892c96669f$var$ScopeSwitcher = ()=>{
    const baseUrl = '';
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { data: board } = (0, $fNi03.useBoard)();
    const [{ data: contextData }] = (0, $4DPZY.useContainerContext)();
    const { data: { user: currentUser } } = (0, $cYlk7.useCurrentUser)();
    const currentBoard = (0, $5uXOq.useMemo)(()=>board != null ? // URL not need as navigation handled via imperative API using board ID
        {
            id: String(board.id),
            name: board.name,
            url: ''
        } : // make switcher appear also on boardless projects
        {
            id: '0',
            name: ' ',
            url: ''
        }, [
        board
    ]);
    let locationName = '';
    if (contextData?.contextType === 'project' && contextData.project.name) locationName = contextData.project.name;
    else if (contextData?.contextType === 'user' && contextData.user.name) locationName = contextData.user.name;
    const onBoardClick = (0, $5uXOq.useCallback)(async (clickedBoard)=>{
        push(clickedBoard.url);
    }, [
        push
    ]);
    const onCreateBoard = (0, $5uXOq.useCallback)(()=>{
        (0, $1ADgn.default)();
    }, []);
    const projectKey = contextData?.contextType === 'project' ? contextData.project.key : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3zdOn.default), {
        key: projectKey,
        baseUrl: baseUrl,
        // @ts-expect-error - TS2322 - Type '{ baseUrl: string; boardsInLocation: { id: string; name: string; url: string; }[]; currentBoard: { id: string; name: string; url: string; }; currentProjectKey: string; currentUserName: string; defaultOpen: false; ... 7 more ...; onNavigateUrl: (path: string, state?: any) => void | Promise<...>; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<ScopeSwitcherApp> & Pick<Readonly<Props> & Readonly<...>, "children" | ... 3 more ... | "onBoardClick"> & Partial<...> & Partial<...>'.
        boardsInLocation: [
            currentBoard
        ],
        currentBoard: currentBoard,
        currentProjectKey: projectKey,
        currentUserName: currentUser.accountId ?? '',
        defaultOpen: false,
        isCreateBoardEnabled: !currentUser.isAnonymous,
        isLocationUser: false,
        isSearchEnabled: true,
        locale: currentUser.locale,
        locationName: locationName,
        onCreateBoard: onCreateBoard,
        onBoardClick: onBoardClick,
        onNavigateUrl: push
    });
};
const $055543892c96669f$export$8d2db9c1a2d8e427 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { data: board } = (0, $fNi03.useBoard)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($055543892c96669f$var$CssFixContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juVrZ.default), {
        description: formatMessage((0, $bdAP2.messages).board),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7c1AG))), {
            spacing: "spacious",
            label: ""
        })
    }, board?.name ?? ''));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($055543892c96669f$var$ScopeSwitcher, null);
};
const $055543892c96669f$var$CssFixContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1lfu1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7c1AG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b897b2ce2a13d32e1a5cc9d6fdc4caf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53cae3443e539c96$var$_react = $53cae3443e539c96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $53cae3443e539c96$var$_boards = $53cae3443e539c96$var$_interopRequireDefault((parcelRequire("aq6ZY")));

var $53cae3443e539c96$var$_switcher = $53cae3443e539c96$var$_interopRequireDefault((parcelRequire("3pAfJ")));
function $53cae3443e539c96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardsIcon.
 * This component is BoardsIcon, with `UNSAFE_fallbackIcon` set to "SwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved as the icon to represent multiple boards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53cae3443e539c96$var$BoardsIcon = (props)=>/*#__PURE__*/ $53cae3443e539c96$var$_react.default.createElement($53cae3443e539c96$var$_boards.default, Object.assign({
        LEGACY_fallbackIcon: $53cae3443e539c96$var$_switcher.default
    }, props));
$53cae3443e539c96$var$BoardsIcon.Name = 'BoardsIconMigration';
var $53cae3443e539c96$var$_default = module.exports.default = $53cae3443e539c96$var$BoardsIcon;

});
parcelRegister("aq6ZY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::645b121bd5918c466000b65adda09490>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7961c2da485bd49c$var$_react = $7961c2da485bd49c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7961c2da485bd49c$var$_baseNew = $7961c2da485bd49c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7961c2da485bd49c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Boards".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved as the icon to represent multiple boards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7961c2da485bd49c$var$BoardsIcon = (props)=>/*#__PURE__*/ $7961c2da485bd49c$var$_react.default.createElement($7961c2da485bd49c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h1.833v-7zm3.333 0v7h2.334v-7zm3.834 0v7H11a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm14.5 7.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75" clip-rule="evenodd"/>`
    }, props));
$7961c2da485bd49c$var$BoardsIcon.displayName = 'BoardsIcon';
var $7961c2da485bd49c$var$_default = module.exports.default = $7961c2da485bd49c$var$BoardsIcon;

});

parcelRegister("3pAfJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27bfd3ee9e06e335$var$_react = $27bfd3ee9e06e335$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $27bfd3ee9e06e335$var$_boards = $27bfd3ee9e06e335$var$_interopRequireDefault((parcelRequire("aq6ZY")));
function $27bfd3ee9e06e335$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $27bfd3ee9e06e335$var$SwitcherIcon = (props)=>/*#__PURE__*/ $27bfd3ee9e06e335$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M3.507 15H16.5c-.007 0-.007-10-.007-10H3.5c.007 0 .007 10 .007 10M1.5 4.994C1.5 3.893 2.263 3 3.192 3h13.616c.934 0 1.692.895 1.692 1.994v10.012c0 1.101-.763 1.994-1.692 1.994H3.192c-.934 0-1.692-.895-1.692-1.994zM6.5 5v10h2V5zm5 0v10h2V5z"/><path d="M20.5 5h.006c1.101 0 1.994.895 1.994 1.994v12.012A1.995 1.995 0 0 1 20.506 21H8.494A1.995 1.995 0 0 1 6.5 19.006V19h13c.555 0 1-.448 1-1z"/></g></svg>`
    }, props, {
        newIcon: $27bfd3ee9e06e335$var$_boards.default
    }));
$27bfd3ee9e06e335$var$SwitcherIcon.displayName = 'SwitcherIcon';
var $27bfd3ee9e06e335$var$_default = module.exports.default = $27bfd3ee9e06e335$var$SwitcherIcon;

});


parcelRegister("juVrZ", function(module, exports) {

$parcel$export(module.exports, "Container", () => $c46eefd51badc16b$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $c46eefd51badc16b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jSfqD = parcelRequire("jSfqD");
const $c46eefd51badc16b$var$styles = {
    header: "_vrjt140y _1cmd10s3 _1cg71wug _11kj1w7a _jl2n73ad _1et61w7a _1v6j10s3"
};
const $c46eefd51badc16b$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c46eefd51badc16b$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ...props,
        ref: ref,
        component: props.component || $c46eefd51badc16b$export$42a852a2b6b56249,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
                        ...props,
                        children: children
                    })
            }
        },
        className: (0, $bwpsq.default)([
            $c46eefd51badc16b$var$styles.header
        ])
    });
});
var $c46eefd51badc16b$export$2e2bcd8739ae039 = $c46eefd51badc16b$var$Header;

});

parcelRegister("1ADgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5ce13af6407cab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $7T84i.loadBridgeStrict)({
        name: $7a5ce13af6407cab$var$amdModuleName,
        wrmKeys: [
            'wrc!com.pyxis.greenhopper.jira:gh-create-board'
        ]
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});
parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});

parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});


parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});





parcelRegister("3zdOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9d3f4c22394aed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jD5no = parcelRequire("jD5no");

var $Lkw08 = parcelRequire("Lkw08");

var $2rxWW = parcelRequire("2rxWW");

var $36kWF = parcelRequire("36kWF");

var $iMWMK = parcelRequire("iMWMK");
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
const $1f9d3f4c22394aed$var$mapBoard = ({ id: id, ...rest })=>({
        id: String(id),
        ...rest
    });
class $1f9d3f4c22394aed$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isCreateBoardEnabled: false,
            isLocationUser: false,
            baseUrl: '',
            defaultOpen: false,
            projectName: '',
            onCreateBoard: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onNavigateUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $36kWF.default)((0, $Lkw08.default));
        this.setUpContext(props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setUpContext(nextProps);
    }
    setUpContext(props) {
        const { baseUrl: baseUrl, currentBoard: currentBoard, onBoardClick: onBoardClick, onNavigateUrl: onNavigateUrl, currentProjectKey: currentProjectKey } = props;
        this.store.dispatch((0, $2rxWW.setUpContext)({
            baseUrl: baseUrl,
            // @ts-expect-error - TS2322 - Type '{ id: string; } | undefined' is not assignable to type 'Board | undefined'.
            currentBoard: currentBoard ? $1f9d3f4c22394aed$var$mapBoard(currentBoard) : currentBoard,
            onBoardClick: onBoardClick,
            onNavigateUrl: onNavigateUrl,
            currentProjectKey: currentProjectKey
        }));
    }
    render() {
        const { defaultOpen: defaultOpen, isCreateBoardEnabled: isCreateBoardEnabled, isLocationUser: isLocationUser, onCreateBoard: onCreateBoard, locationName: locationName } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMWMK.default), {
            // @ts-expect-error - Property 'defaultOpen' does not exist on props
            defaultOpen: defaultOpen,
            isLocationUser: isLocationUser,
            locationName: locationName,
            hasCreateBoardButton: isCreateBoardEnabled,
            onCreateBoard: onCreateBoard
        }));
    }
}

});
parcelRegister("Lkw08", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c73c2efd424dd26$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $9qKDu = parcelRequire("9qKDu");

var $iYER9 = parcelRequire("iYER9");

var $6u1OS = parcelRequire("6u1OS");

var $kNymF = parcelRequire("kNymF");

var $hln65 = parcelRequire("hln65");
var $7c73c2efd424dd26$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $iYER9.fetchInitialBoardsEpic), (0, $hln65.searchBoardsEpic), (0, $9qKDu.onItemClick), (0, $6u1OS.loadMoreEpic), (0, $kNymF.retryEpic));

});
parcelRegister("9qKDu", function(module, exports) {

$parcel$export(module.exports, "onItemClick", () => $3df5c92d10e7b8f9$export$20c413ae3260f4f0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
const $3df5c92d10e7b8f9$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.item-click';
const $3df5c92d10e7b8f9$export$20c413ae3260f4f0 = (action$, store)=>action$.ofType((0, $2rxWW.ITEM_CLICKED)).mergeMap((action)=>{
        const { id: id, isViewAll: isViewAll } = action.payload;
        const state = store.getState();
        const onNavigateUrl = (0, $1oWhI.getOnNavigateUrl)(state);
        // view all was clicked
        if (isViewAll) {
            onNavigateUrl((0, $1oWhI.getViewAllUrl)(state));
            return (0, $kVLXA.Observable).empty();
        }
        // board was clicked
        const board = (0, $1oWhI.getBoardById)(state, id);
        if (!board) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData($3df5c92d10e7b8f9$export$103bedf43ba882db, 'Tried to click on board which does not exist');
            return (0, $kVLXA.Observable).empty();
        }
        const onBoardClick = (0, $1oWhI.getOnBoardClick)(state);
        onBoardClick(board, (0, $1oWhI.isBoardInLocation)(state, board));
        return (0, $kVLXA.Observable).of((0, $2rxWW.setRecentlyClickedItem)(id));
    });

});
parcelRegister("2rxWW", function(module, exports) {

$parcel$export(module.exports, "FETCH_INITIAL_BOARDS", () => $2c2ab6c7d54a4c3f$export$5814f5dbd0e4defd);
$parcel$export(module.exports, "fetchInitialBoards", () => $2c2ab6c7d54a4c3f$export$3590168539f726b6);
$parcel$export(module.exports, "START_FETCHING_INITIAL_BOARDS", () => $2c2ab6c7d54a4c3f$export$20604d59ee87223);
$parcel$export(module.exports, "startFetchingInitialBoards", () => $2c2ab6c7d54a4c3f$export$64d54000aec63db2);
$parcel$export(module.exports, "INITIAL_BOARDS_FETCHED", () => $2c2ab6c7d54a4c3f$export$87e24a43d036c1e5);
$parcel$export(module.exports, "initialBoardsFetched", () => $2c2ab6c7d54a4c3f$export$dbfcdbabfdf3bf51);
$parcel$export(module.exports, "INITIAL_BOARDS_FETCH_FAILURE", () => $2c2ab6c7d54a4c3f$export$4a4c0d78288f6cc9);
$parcel$export(module.exports, "initialBoardsFetchFailure", () => $2c2ab6c7d54a4c3f$export$211b282993bd486e);
$parcel$export(module.exports, "SET_UP_CONTEXT", () => $2c2ab6c7d54a4c3f$export$29b131a6dc592198);
$parcel$export(module.exports, "setUpContext", () => $2c2ab6c7d54a4c3f$export$7f11c4a72483f26e);
$parcel$export(module.exports, "ITEM_CLICKED", () => $2c2ab6c7d54a4c3f$export$2851e3c0f224fb8);
$parcel$export(module.exports, "itemClicked", () => $2c2ab6c7d54a4c3f$export$a69a8075bfb04cc8);
$parcel$export(module.exports, "SET_RECENTLY_CLICKED_ITEM", () => $2c2ab6c7d54a4c3f$export$ead64e29386c273);
$parcel$export(module.exports, "setRecentlyClickedItem", () => $2c2ab6c7d54a4c3f$export$9ee49063ac41671c);
$parcel$export(module.exports, "SEARCH_CHANGED", () => $2c2ab6c7d54a4c3f$export$a3d24dda7ab3bf20);
$parcel$export(module.exports, "changeSearch", () => $2c2ab6c7d54a4c3f$export$423e386eae2eeca4);
$parcel$export(module.exports, "SEARCH_SUCCESS", () => $2c2ab6c7d54a4c3f$export$bcf46bdbaf9ada45);
$parcel$export(module.exports, "searchSuccess", () => $2c2ab6c7d54a4c3f$export$538de7f69e830e13);
$parcel$export(module.exports, "SEARCH_FAILURE", () => $2c2ab6c7d54a4c3f$export$8799d6d9051924fe);
$parcel$export(module.exports, "searchFailure", () => $2c2ab6c7d54a4c3f$export$6634344b3cfbac37);
$parcel$export(module.exports, "LOAD_MORE", () => $2c2ab6c7d54a4c3f$export$64a7c8ea6b049312);
$parcel$export(module.exports, "loadMore", () => $2c2ab6c7d54a4c3f$export$b346ae7c9d204e07);
$parcel$export(module.exports, "LOAD_MORE_SUCCESS", () => $2c2ab6c7d54a4c3f$export$af8844515dcab66a);
$parcel$export(module.exports, "loadMoreSuccess", () => $2c2ab6c7d54a4c3f$export$352633e2f9f75426);
$parcel$export(module.exports, "LOAD_MORE_FAILURE", () => $2c2ab6c7d54a4c3f$export$66c2ca6df6311f13);
$parcel$export(module.exports, "loadMoreFailure", () => $2c2ab6c7d54a4c3f$export$a5ef50c2daec45c6);
$parcel$export(module.exports, "FETCHED_BOARD_OWNER_ACCOUNT_ID", () => $2c2ab6c7d54a4c3f$export$17fef7ac68281f47);
$parcel$export(module.exports, "fetchedBoardOwnerAccountId", () => $2c2ab6c7d54a4c3f$export$b23c0c6b4bd9a29b);
$parcel$export(module.exports, "RETRY", () => $2c2ab6c7d54a4c3f$export$49428740fd4b1483);
$parcel$export(module.exports, "retry", () => $2c2ab6c7d54a4c3f$export$9369b12211e1fce4);
const $2c2ab6c7d54a4c3f$export$5814f5dbd0e4defd = 'state.FETCH_INITIAL_BOARDS';
const $2c2ab6c7d54a4c3f$export$3590168539f726b6 = (forceRetrieve = false)=>({
        type: $2c2ab6c7d54a4c3f$export$5814f5dbd0e4defd,
        payload: forceRetrieve
    });
const $2c2ab6c7d54a4c3f$export$20604d59ee87223 = 'state.START_FETCHING_INITIAL_BOARDS';
const $2c2ab6c7d54a4c3f$export$64d54000aec63db2 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$20604d59ee87223
    });
const $2c2ab6c7d54a4c3f$export$87e24a43d036c1e5 = 'state.INITIAL_BOARDS_FETCHED';
const $2c2ab6c7d54a4c3f$export$dbfcdbabfdf3bf51 = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$87e24a43d036c1e5,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$4a4c0d78288f6cc9 = 'state.INITIAL_BOARDS_FETCH_FAILURE';
const $2c2ab6c7d54a4c3f$export$211b282993bd486e = ()=>({
        type: $2c2ab6c7d54a4c3f$export$4a4c0d78288f6cc9
    });
const $2c2ab6c7d54a4c3f$export$29b131a6dc592198 = 'state.SET_UP_CONTEXT';
const $2c2ab6c7d54a4c3f$export$7f11c4a72483f26e = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$29b131a6dc592198,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$2851e3c0f224fb8 = 'state.ITEM_CLICKED';
const $2c2ab6c7d54a4c3f$export$a69a8075bfb04cc8 = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$2851e3c0f224fb8,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$ead64e29386c273 = 'state.SET_RECENTLY_CLICKED_ITEM';
const $2c2ab6c7d54a4c3f$export$9ee49063ac41671c = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$ead64e29386c273,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$a3d24dda7ab3bf20 = 'state.SEARCH_CHANGED';
const $2c2ab6c7d54a4c3f$export$423e386eae2eeca4 = (search)=>({
        type: $2c2ab6c7d54a4c3f$export$a3d24dda7ab3bf20,
        payload: search
    });
const $2c2ab6c7d54a4c3f$export$bcf46bdbaf9ada45 = 'state.SEARCH_SUCCESS';
const $2c2ab6c7d54a4c3f$export$538de7f69e830e13 = (inLocation, notInLocation)=>({
        type: $2c2ab6c7d54a4c3f$export$bcf46bdbaf9ada45,
        payload: {
            inLocation: inLocation,
            notInLocation: notInLocation
        }
    });
const $2c2ab6c7d54a4c3f$export$8799d6d9051924fe = 'state.SEARCH_FAILURE';
const $2c2ab6c7d54a4c3f$export$6634344b3cfbac37 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$8799d6d9051924fe
    });
const $2c2ab6c7d54a4c3f$export$64a7c8ea6b049312 = 'state.LOAD_MORE';
const $2c2ab6c7d54a4c3f$export$b346ae7c9d204e07 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$64a7c8ea6b049312
    });
const $2c2ab6c7d54a4c3f$export$af8844515dcab66a = 'state.LOAD_MORE_SUCCESS';
const $2c2ab6c7d54a4c3f$export$352633e2f9f75426 = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$af8844515dcab66a,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$66c2ca6df6311f13 = 'state.LOAD_MORE_FAILURE';
const $2c2ab6c7d54a4c3f$export$a5ef50c2daec45c6 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$66c2ca6df6311f13
    });
const $2c2ab6c7d54a4c3f$export$17fef7ac68281f47 = 'state.FETCHED_BOARD_OWNER_ACCOUNT_ID';
const $2c2ab6c7d54a4c3f$export$b23c0c6b4bd9a29b = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$17fef7ac68281f47,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$49428740fd4b1483 = 'state.RETRY';
const $2c2ab6c7d54a4c3f$export$9369b12211e1fce4 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$49428740fd4b1483
    });

});

parcelRegister("1oWhI", function(module, exports) {

$parcel$export(module.exports, "getInitialBoardsProps", () => $6eebaf74836a76d2$export$e7ef9b75e4bfbaf3);
$parcel$export(module.exports, "getBaseUrl", () => $6eebaf74836a76d2$export$f654b28f82155665);
$parcel$export(module.exports, "getBoardsInLocation", () => $6eebaf74836a76d2$export$2ada7be29e6d80c3);
$parcel$export(module.exports, "isBoardInLocation", () => $6eebaf74836a76d2$export$cafdce7d03168152);
$parcel$export(module.exports, "getOnNavigateUrl", () => $6eebaf74836a76d2$export$dcfbefab6f455ad3);
$parcel$export(module.exports, "getOnBoardClick", () => $6eebaf74836a76d2$export$d2238358884d2e10);
$parcel$export(module.exports, "getRecentBoards", () => $6eebaf74836a76d2$export$bf57948c9c2c2673);
$parcel$export(module.exports, "wereInitialBoardsFetched", () => $6eebaf74836a76d2$export$26420cdb4a84f7af);
$parcel$export(module.exports, "isLoadingInitialBoards", () => $6eebaf74836a76d2$export$559b671f5355707b);
$parcel$export(module.exports, "getSelectedBoard", () => $6eebaf74836a76d2$export$2789c573cd3f4849);
$parcel$export(module.exports, "getBoardById", () => $6eebaf74836a76d2$export$5a42d7caeec6e4e3);
$parcel$export(module.exports, "getLocationType", () => $6eebaf74836a76d2$export$a396f8065cc6929f);
$parcel$export(module.exports, "getLocationKey", () => $6eebaf74836a76d2$export$b134c52b507d6901);
$parcel$export(module.exports, "shouldLoadBoardOwnerAccountId", () => $6eebaf74836a76d2$export$e20cc77952fdf4ad);
$parcel$export(module.exports, "getRecentlyClickedBoard", () => $6eebaf74836a76d2$export$c1276a6838e2c69a);
$parcel$export(module.exports, "getViewAllUrl", () => $6eebaf74836a76d2$export$96e8b39eed587a1e);
$parcel$export(module.exports, "getSearchValue", () => $6eebaf74836a76d2$export$879e545af11703e9);
$parcel$export(module.exports, "getSearchResults", () => $6eebaf74836a76d2$export$cfcc0908d6dfb8a6);
$parcel$export(module.exports, "isSearchUsed", () => $6eebaf74836a76d2$export$e611265f491331e2);
$parcel$export(module.exports, "shouldRetryLoadMore", () => $6eebaf74836a76d2$export$5ffd0b29710da22a);
$parcel$export(module.exports, "getShowMoreStartAt", () => $6eebaf74836a76d2$export$14d8d5f03e067455);
$parcel$export(module.exports, "isLoadingMore", () => $6eebaf74836a76d2$export$86270845ad5760df);
$parcel$export(module.exports, "isLoading", () => $6eebaf74836a76d2$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $6eebaf74836a76d2$export$e6127cc7fe7395c3);

var $jrHLm = parcelRequire("jrHLm");
const $6eebaf74836a76d2$export$e7ef9b75e4bfbaf3 = (state)=>state.initialBoards;
const $6eebaf74836a76d2$export$327c9d9fb55ff015 = (state)=>state.currentProjectKey;
const $6eebaf74836a76d2$export$f654b28f82155665 = (state)=>state.baseUrl;
const $6eebaf74836a76d2$export$2ada7be29e6d80c3 = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).inLocation.values;
const $6eebaf74836a76d2$export$cafdce7d03168152 = (state, board)=>$6eebaf74836a76d2$export$2ada7be29e6d80c3(state).includes(board);
const $6eebaf74836a76d2$export$dcfbefab6f455ad3 = (state)=>state.onNavigateUrl;
const $6eebaf74836a76d2$export$d2238358884d2e10 = (state)=>state.onBoardClick;
const $6eebaf74836a76d2$export$bf57948c9c2c2673 = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).recent;
const $6eebaf74836a76d2$export$26420cdb4a84f7af = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).wereFetched;
const $6eebaf74836a76d2$export$559b671f5355707b = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).isInProgress;
const $6eebaf74836a76d2$export$56a1664ae598b02d = (state)=>state.boardOwnerAccountId;
const $6eebaf74836a76d2$export$2789c573cd3f4849 = (state)=>state.currentBoard;
const $6eebaf74836a76d2$export$5a42d7caeec6e4e3 = (state, id)=>{
    if (!id) return undefined;
    const test = (board)=>board.id === id;
    return $6eebaf74836a76d2$export$2ada7be29e6d80c3(state).find(test) || $6eebaf74836a76d2$export$bf57948c9c2c2673(state).find(test) || state.searchResults && (state.searchResults.inLocation.values.find(test) || state.searchResults.notInLocation.values.find(test));
};
const $6eebaf74836a76d2$export$a396f8065cc6929f = (state)=>$6eebaf74836a76d2$export$327c9d9fb55ff015(state) ? (0, $jrHLm.ProjectLocation) : (0, $jrHLm.UserAccountLocation);
const $6eebaf74836a76d2$export$b134c52b507d6901 = (state)=>{
    switch($6eebaf74836a76d2$export$a396f8065cc6929f(state)){
        case 0, $jrHLm.ProjectLocation:
            return $6eebaf74836a76d2$export$327c9d9fb55ff015(state);
        default:
            return $6eebaf74836a76d2$export$56a1664ae598b02d(state);
    }
};
const $6eebaf74836a76d2$export$e20cc77952fdf4ad = (state)=>$6eebaf74836a76d2$export$a396f8065cc6929f(state) === (0, $jrHLm.UserAccountLocation) && !$6eebaf74836a76d2$export$56a1664ae598b02d(state);
const $6eebaf74836a76d2$export$a8e22a0e0ed1bd80 = (state)=>state.recentlyClickedItem;
const $6eebaf74836a76d2$export$c1276a6838e2c69a = (state)=>$6eebaf74836a76d2$export$5a42d7caeec6e4e3(state, $6eebaf74836a76d2$export$a8e22a0e0ed1bd80(state));
const $6eebaf74836a76d2$export$96e8b39eed587a1e = (state)=>`${$6eebaf74836a76d2$export$f654b28f82155665(state)}/jira/boards`;
const $6eebaf74836a76d2$export$97866788cd97f572 = (state)=>state.isSearchInProgress;
const $6eebaf74836a76d2$export$879e545af11703e9 = (state)=>state.searchValue;
const $6eebaf74836a76d2$export$cfcc0908d6dfb8a6 = (state)=>state.searchResults;
const $6eebaf74836a76d2$export$e611265f491331e2 = (state)=>!!state.searchValue;
const $6eebaf74836a76d2$export$5ffd0b29710da22a = (state)=>state.shouldRetryLoadMore;
const $6eebaf74836a76d2$export$14d8d5f03e067455 = (state)=>($6eebaf74836a76d2$export$e611265f491331e2(state) ? $6eebaf74836a76d2$export$cfcc0908d6dfb8a6(state) : $6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state)).inLocation.values.length;
const $6eebaf74836a76d2$export$86270845ad5760df = (state)=>state.isLoadMoreInProgress;
const $6eebaf74836a76d2$export$20bb0d907fbbe433 = (state)=>$6eebaf74836a76d2$export$559b671f5355707b(state) || $6eebaf74836a76d2$export$97866788cd97f572(state) || $6eebaf74836a76d2$export$86270845ad5760df(state) && $6eebaf74836a76d2$export$5ffd0b29710da22a(state);
const $6eebaf74836a76d2$export$e491bc2266c085a5 = (state)=>state.hasSearchError;
const $6eebaf74836a76d2$export$fb8d5f0b5308c34c = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).hasError;
const $6eebaf74836a76d2$export$465c38c1cadb2c7e = (state)=>!$6eebaf74836a76d2$export$86270845ad5760df(state) && $6eebaf74836a76d2$export$5ffd0b29710da22a(state);
const $6eebaf74836a76d2$export$e6127cc7fe7395c3 = (state)=>$6eebaf74836a76d2$export$465c38c1cadb2c7e(state) || ($6eebaf74836a76d2$export$e611265f491331e2(state) ? $6eebaf74836a76d2$export$e491bc2266c085a5(state) : $6eebaf74836a76d2$export$fb8d5f0b5308c34c(state));

});
parcelRegister("jrHLm", function(module, exports) {

$parcel$export(module.exports, "toAccountId", () => $83fc60eeaef6ba2c$export$ef1795c9a6f7e7ac);
$parcel$export(module.exports, "ProjectLocation", () => $83fc60eeaef6ba2c$export$3591918cb507380e);
$parcel$export(module.exports, "UserAccountLocation", () => $83fc60eeaef6ba2c$export$2beadc9ea8da06d9);
const $83fc60eeaef6ba2c$export$ef1795c9a6f7e7ac = (value)=>value;
const $83fc60eeaef6ba2c$export$3591918cb507380e = 'ProjectLocation';
const $83fc60eeaef6ba2c$export$2beadc9ea8da06d9 = 'UserAccountLocation';

});



parcelRegister("iYER9", function(module, exports) {

$parcel$export(module.exports, "fetchInitialBoardsEpic", () => $ba4e4217d796e0bf$export$37ce36869151db6c);
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("jFVZ1");
parcelRequire("1oQta");
parcelRequire("6cbqE");
parcelRequire("7Ts1V");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $6LMGB = parcelRequire("6LMGB");

var $l9eSS = parcelRequire("l9eSS");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");

var $c4lIk = parcelRequire("c4lIk");
const $ba4e4217d796e0bf$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.fetch-initial-boards';
const $ba4e4217d796e0bf$export$e87d47297085325a = 15;
const $ba4e4217d796e0bf$export$e13b7e981bb78af = 'navigation-v2.scope-switcher-v2.browser-metrics.fetch-initial-boards';
const $ba4e4217d796e0bf$export$37ce36869151db6c = (action$, store)=>action$.ofType((0, $2rxWW.FETCH_INITIAL_BOARDS)).filter(({ payload: forceRetrieve })=>{
        const state = store.getState();
        const wereRecentBoardsFetched = (0, $1oWhI.wereInitialBoardsFetched)(state);
        const isLoadingRecentBoards = (0, $1oWhI.isLoadingInitialBoards)(state);
        return forceRetrieve || !wereRecentBoardsFetched && !isLoadingRecentBoards;
    }).switchMap(()=>{
        const fetchBoards$ = (locationKey)=>{
            const state = store.getState();
            const baseUrl = (0, $1oWhI.getBaseUrl)(state);
            const locationType = (0, $1oWhI.getLocationType)(state);
            const promise = Promise.all([
                (0, $6LMGB.default)(baseUrl, $ba4e4217d796e0bf$export$e87d47297085325a),
                (0, $l9eSS.default)(baseUrl, undefined, locationType, locationKey)
            ]);
            return (0, $kVLXA.Observable).fromPromise(promise) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([recentBoards, boardsInLocation])=>(0, $2rxWW.initialBoardsFetched)({
                    recentBoards: recentBoards,
                    boardsInLocation: boardsInLocation
                })).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($ba4e4217d796e0bf$export$103bedf43ba882db, error.message, error);
                return (0, $kVLXA.Observable).of((0, $2rxWW.initialBoardsFetchFailure)());
            });
        };
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $2rxWW.startFetchingInitialBoards)()), (0, $c4lIk.default)(store, fetchBoards$, (errorMessage)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($ba4e4217d796e0bf$export$103bedf43ba882db, errorMessage);
            return (0, $2rxWW.initialBoardsFetchFailure)();
        }));
    });

});
parcelRegister("6LMGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd5a7fe6a380d03b$export$2e2bcd8739ae039);

var $4fqrH = parcelRequire("4fqrH");

var $7v1um = parcelRequire("7v1um");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd5a7fe6a380d03b$export$2e2bcd8739ae039 = async (baseUrl, count)=>{
    const { views: views } = await (0, $4fqrH.default)(baseUrl, count);
    return (0, $7v1um.transformRecentBoards)(views);
};

});
parcelRegister("4fqrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7464b4ae610982b9$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
const $7464b4ae610982b9$export$fdddad2cffdefc0b = (baseUrl)=>`${baseUrl}/rest/greenhopper/1.0/rapidviews/recent`;
const $7464b4ae610982b9$export$94df0e59ebebf4a7 = (baseUrl, count)=>`${$7464b4ae610982b9$export$fdddad2cffdefc0b(baseUrl)}?maxResults=${count}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7464b4ae610982b9$export$2e2bcd8739ae039 = async (baseUrl, count)=>{
    const url = $7464b4ae610982b9$export$94df0e59ebebf4a7(baseUrl, count);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (response.ok) return response.json();
    const text = await response.text();
    throw new (0, $jJZqs.default)(response.status, text);
};

});

parcelRegister("7v1um", function(module, exports) {

$parcel$export(module.exports, "transformRecentBoards", () => $5c9e244b8019ba05$export$3d2bb25369a121ce);

var $iJiqx = parcelRequire("iJiqx");
const $5c9e244b8019ba05$var$USER_TYPE_BOARD = 'user';
const $5c9e244b8019ba05$export$3d2bb25369a121ce = (recentBoards)=>recentBoards.map(({ id: id, name: name, isSimpleBoard: isSimpleBoard, location: { displayText: locationName, avatarUrl: locationAvatarUrl, type: type, accountId: accountId, locationKey: locationKey } })=>({
            id: String(id),
            name: name,
            url: (0, $iJiqx.createBoardUrl)(id, locationKey, accountId, isSimpleBoard),
            isLocationUser: type === $5c9e244b8019ba05$var$USER_TYPE_BOARD,
            locationName: locationName,
            locationAvatarUrl: locationAvatarUrl
        }));

});
parcelRegister("iJiqx", function(module, exports) {

$parcel$export(module.exports, "createBoardUrl", () => $500481c9a17afa22$export$7037e05c8c7af6dc);
const $500481c9a17afa22$export$7037e05c8c7af6dc = (boardId, locationKey, accountId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isNextGenBoard)=>{
    if (isNextGenBoard) return `/jira/software/projects/${locationKey}/boards/${boardId}`;
    if (accountId != null) return `/jira/people/${accountId}/boards/${boardId}`;
    if (locationKey) return `/jira/software/c/projects/${locationKey}/boards/${boardId}`;
    return `/secure/RapidBoard.jspa?rapidView=${boardId}&useStoredSettings=true&locationless=true`;
};

});



parcelRegister("l9eSS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1c97bd43e2c2c27$export$2e2bcd8739ae039);

var $iLGQh = parcelRequire("iLGQh");

var $rw2sW = parcelRequire("rw2sW");
const $f1c97bd43e2c2c27$var$searchBoards = async (baseUrl, search, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
locationType, locationKey, negateLocationFiltering = false, startAt = 0)=>{
    const response = await (0, $iLGQh.default)(baseUrl, search, locationType, locationKey, negateLocationFiltering, startAt);
    return (0, $rw2sW.transformSearchResponseBoards)(response);
};
var $f1c97bd43e2c2c27$export$2e2bcd8739ae039 = $f1c97bd43e2c2c27$var$searchBoards;

});
parcelRegister("iLGQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b46142d6e0453a3$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");


var $jrHLm = parcelRequire("jrHLm");
const $6b46142d6e0453a3$export$fdddad2cffdefc0b = (baseUrl)=>`${baseUrl}/rest/agile/1.0/board`;
const $6b46142d6e0453a3$var$getLocationQueryParamName = (locationType)=>{
    switch(locationType){
        case 0, $jrHLm.ProjectLocation:
            return 'projectLocation';
        case 0, $jrHLm.UserAccountLocation:
            return 'accountIdLocation';
        default:
            return 'usernameLocation';
    }
};
const $6b46142d6e0453a3$export$94df0e59ebebf4a7 = (baseUrl, search, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
locationType, locationKey, negateLocationFiltering, startAt)=>{
    const locationParamName = $6b46142d6e0453a3$var$getLocationQueryParamName(locationType);
    const params = {
        ...search ? {
            name: search
        } : {},
        negateLocationFiltering: negateLocationFiltering,
        orderBy: (0, $ab186e26e08820dd$export$129fc3a353d7068b),
        maxResults: (0, $ab186e26e08820dd$export$b476a41a1b575909),
        startAt: startAt,
        [locationParamName]: locationKey,
        overrideFilterPermissions: true
    };
    const rawUrl = $6b46142d6e0453a3$export$fdddad2cffdefc0b(baseUrl);
    return `${rawUrl}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(params)}`;
};
const $6b46142d6e0453a3$var$getSearchBoards = async (baseUrl, search, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
locationType, locationKey, negateLocationFiltering = false, startAt = 0)=>{
    const url = $6b46142d6e0453a3$export$94df0e59ebebf4a7(baseUrl, search, locationType, locationKey, negateLocationFiltering, startAt);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (!response.ok) {
        const text = await response.text();
        throw new (0, $jJZqs.default)(response.status, text);
    }
    return response.json();
};
var $6b46142d6e0453a3$export$2e2bcd8739ae039 = $6b46142d6e0453a3$var$getSearchBoards;

});
const $ab186e26e08820dd$export$129fc3a353d7068b = 'name';
const $ab186e26e08820dd$export$b476a41a1b575909 = 15;


parcelRegister("rw2sW", function(module, exports) {

$parcel$export(module.exports, "transformSearchResponseBoards", () => $b368d39b4af2df13$export$8c349928f06a6ca8);

var $iJiqx = parcelRequire("iJiqx");
const $b368d39b4af2df13$export$8c349928f06a6ca8 = (response)=>{
    const { values: values, total: total } = response;
    const boards = values.map(({ id: id, name: name, location: location, type: type })=>({
            id: String(id),
            name: name,
            url: (0, $iJiqx.createBoardUrl)(id, location && location.projectKey || '', location?.userAccountId, type === 'simple'),
            ...location ? {
                locationName: location.name,
                isLocationUser: !!location.userId,
                locationAvatarUrl: location.avatarURI
            } : {}
        }));
    return {
        values: boards,
        total: total
    };
};

});


parcelRegister("c4lIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ec29f4b678456a3$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("jFVZ1");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $er6iG = parcelRequire("er6iG");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ec29f4b678456a3$export$2e2bcd8739ae039 = (store, // eslint-disable-next-line @typescript-eslint/no-explicit-any
locationKeyConsumer$, onFailure)=>{
    const state = store.getState();
    const baseUrl = (0, $1oWhI.getBaseUrl)(state);
    const selectedBoard = (0, $1oWhI.getSelectedBoard)(state);
    if ((0, $1oWhI.shouldLoadBoardOwnerAccountId)(state)) {
        if (!selectedBoard) return (0, $kVLXA.Observable).of(onFailure('Cannot fetch board owner account id if there is no selected board'));
        return (0, $kVLXA.Observable).fromPromise((0, $er6iG.default)(baseUrl, selectedBoard.id)).mergeMap((accountId)=>(0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $2rxWW.fetchedBoardOwnerAccountId)(accountId)), locationKeyConsumer$(accountId))).catch((error)=>(0, $kVLXA.Observable).of(onFailure(error.message)));
    }
    const locationKey = (0, $1oWhI.getLocationKey)(state);
    if (!locationKey) return (0, $kVLXA.Observable).of(onFailure('Cannot find current location key'));
    return locationKeyConsumer$(locationKey);
};

});
parcelRegister("er6iG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9acb3e420aa6b6f2$export$2e2bcd8739ae039);

var $ivv3h = parcelRequire("ivv3h");

var $siKDy = parcelRequire("siKDy");
const $9acb3e420aa6b6f2$var$searchBoards = async (baseUrl, boardId)=>{
    const response = await (0, $ivv3h.default)(baseUrl, boardId);
    return (0, $siKDy.transformUserAccountFromBoard)(baseUrl, response);
};
var $9acb3e420aa6b6f2$export$2e2bcd8739ae039 = $9acb3e420aa6b6f2$var$searchBoards;

});
parcelRegister("ivv3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b019e5276160391c$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
const $b019e5276160391c$export$94df0e59ebebf4a7 = (baseUrl, boardId)=>`${baseUrl}/rest/agile/1.0/board/${boardId}`;
const $b019e5276160391c$var$getBoard = async (baseUrl, boardId)=>{
    const url = $b019e5276160391c$export$94df0e59ebebf4a7(baseUrl, boardId);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (!response.ok) {
        const text = await response.text();
        throw new (0, $jJZqs.default)(response.status, text);
    }
    return response.json();
};
var $b019e5276160391c$export$2e2bcd8739ae039 = $b019e5276160391c$var$getBoard;

});

parcelRegister("siKDy", function(module, exports) {

$parcel$export(module.exports, "transformUserAccountFromBoard", () => $2803ec68a897e024$export$33865eda98273d51);

var $jrHLm = parcelRequire("jrHLm");
const $2803ec68a897e024$export$33865eda98273d51 = (baseUrl, response)=>{
    if (response && response.location && response.location.userAccountId) return (0, $jrHLm.toAccountId)(response.location.userAccountId);
    throw new Error('Expected userAccountId to appear in the response');
};

});




parcelRegister("6u1OS", function(module, exports) {

$parcel$export(module.exports, "loadMoreEpic", () => $387184df5fa5af72$export$e73907735bd2fde0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("7qVV7");
parcelRequire("c66Ur");
parcelRequire("7Ts1V");

var $2YZCu = parcelRequire("2YZCu");

var $l9eSS = parcelRequire("l9eSS");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
const $387184df5fa5af72$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.load-more';
const $387184df5fa5af72$export$e13b7e981bb78af = 'navigation-apps.scope-switcher-v2.browser-metrics.load-more';
const $387184df5fa5af72$export$e73907735bd2fde0 = (action$, store)=>{
    const stopActions$ = action$.ofType((0, $2rxWW.SEARCH_CHANGED));
    return action$.ofType((0, $2rxWW.LOAD_MORE)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $1oWhI.getBaseUrl)(state);
        const locationType = (0, $1oWhI.getLocationType)(state);
        const locationKey = (0, $1oWhI.getLocationKey)(state);
        const value = (0, $1oWhI.isSearchUsed)(state) ? (0, $1oWhI.getSearchValue)(state) : undefined;
        const startAt = (0, $1oWhI.getShowMoreStartAt)(state);
        if (!locationKey) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData($387184df5fa5af72$export$103bedf43ba882db, 'Location key does not exist');
            return (0, $kVLXA.Observable).of((0, $2rxWW.loadMoreFailure)());
        }
        return (0, $kVLXA.Observable).fromPromise((0, $l9eSS.default)(baseUrl, value, locationType, locationKey, false, startAt)).mergeMap((inLocation)=>(0, $kVLXA.Observable).of((0, $2rxWW.loadMoreSuccess)(inLocation))).takeUntil(stopActions$).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($387184df5fa5af72$export$103bedf43ba882db, error.message, error);
            return (0, $kVLXA.Observable).of((0, $2rxWW.loadMoreFailure)());
        });
    });
};

});

parcelRegister("kNymF", function(module, exports) {

$parcel$export(module.exports, "retryEpic", () => $2cec3f4512347eb6$export$df8d455716799b54);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
const $2cec3f4512347eb6$export$df8d455716799b54 = (action$, store)=>// @ts-expect-error - TS2322 - Type 'Observable<LoadMoreAction>' is not assignable to type 'Observable<State>'. | TS2345 - Argument of type '() => Observable<LoadMoreAction> | Observable<SearchChangedAction>' is not assignable to parameter of type '(value: State, index: number) => ObservableInput<LoadMoreAction>'.
    action$.ofType((0, $2rxWW.RETRY)).mergeMap(()=>{
        const state = store.getState();
        const isSearchUsed = (0, $1oWhI.isSearchUsed)(state);
        const searchValue = (0, $1oWhI.getSearchValue)(state);
        const shouldRetryLoadMore = (0, $1oWhI.shouldRetryLoadMore)(state);
        if (shouldRetryLoadMore) return (0, $kVLXA.Observable).of((0, $2rxWW.loadMore)());
        if (isSearchUsed) return (0, $kVLXA.Observable).of((0, $2rxWW.changeSearch)(searchValue));
        // @ts-expect-error - TS2769 - No overload matches this call.
        return (0, $kVLXA.Observable).of((0, $2rxWW.changeSearch)(''), (0, $2rxWW.fetchInitialBoards)());
    });

});

parcelRegister("hln65", function(module, exports) {

$parcel$export(module.exports, "searchBoardsEpic", () => $481bde5902701fc2$export$c6cd5fc1f50be3d4);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("7Ts1V");

var $2YZCu = parcelRequire("2YZCu");

var $l9eSS = parcelRequire("l9eSS");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");

var $c4lIk = parcelRequire("c4lIk");
const $481bde5902701fc2$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.search-boards';
const $481bde5902701fc2$export$e13b7e981bb78af = 'navigation-apps.scope-switcher-v2.browser-metrics.search-boards';
const $481bde5902701fc2$export$c6cd5fc1f50be3d4 = (action$, store)=>action$.ofType((0, $2rxWW.SEARCH_CHANGED)).filter(({ payload: value })=>!!value.length).mergeMap(()=>{
        const searchBoards$ = (locationKey)=>{
            const state = store.getState();
            const baseUrl = (0, $1oWhI.getBaseUrl)(state);
            const search = (0, $1oWhI.getSearchValue)(state);
            const locationType = (0, $1oWhI.getLocationType)(state);
            const searchBoardsPromise = Promise.all([
                (0, $l9eSS.default)(baseUrl, search, locationType, locationKey),
                (0, $l9eSS.default)(baseUrl, search, locationType, locationKey, true)
            ]);
            return (0, $kVLXA.Observable).fromPromise(searchBoardsPromise) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([searchedBoardsInLocation, searchedBoardsNotInLocation])=>(0, $2rxWW.searchSuccess)(searchedBoardsInLocation, searchedBoardsNotInLocation)).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($481bde5902701fc2$export$103bedf43ba882db, error.message, error);
                return (0, $kVLXA.Observable).of((0, $2rxWW.searchFailure)());
            });
        };
        return (0, $c4lIk.default)(store, searchBoards$, (errorMessage)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($481bde5902701fc2$export$103bedf43ba882db, errorMessage);
            return (0, $2rxWW.searchFailure)();
        });
    });

});


parcelRegister("36kWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc94c2b34701a21$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $ac3n8 = parcelRequire("ac3n8");

var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$fbc94c2b34701a21$export$2e2bcd8739ae039 = (rootOperation)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const middlewares = [];
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    return (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)((0, $ac3n8.default)), (0, $ac3n8.initialState), (0, $hkadP.default)({
        name: 'ScopeSwitcher'
    })((0, $3f2cs.applyMiddleware)(...middlewares, (0, $e1AU2.createEpicMiddleware)(rootOperation))));
};

});
parcelRegister("ac3n8", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ff6d7c7bd67ca8f0$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $ff6d7c7bd67ca8f0$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $3JOCw = parcelRequire("3JOCw");

var $2rxWW = parcelRequire("2rxWW");
const $ff6d7c7bd67ca8f0$var$emptyBoardsList = ()=>({
        values: [],
        total: 0
    });
const $ff6d7c7bd67ca8f0$export$d4c72bab9d6cc13a = {
    currentProjectKey: undefined,
    initialBoards: {
        inLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList(),
        recent: [],
        wereFetched: false,
        isInProgress: false,
        hasError: false
    },
    currentBoard: undefined,
    searchResults: {
        inLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList(),
        notInLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList()
    },
    boardOwnerAccountId: undefined,
    isSearchInProgress: false,
    isLoadMoreInProgress: false,
    shouldRetryLoadMore: false,
    hasSearchError: false,
    searchValue: '',
    viewAllUrl: '',
    baseUrl: '',
    recentlyClickedItem: undefined,
    // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type 'OnBoardClick'.
    onBoardClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onNavigateUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $ff6d7c7bd67ca8f0$var$patchInitialBoards = (state, initialBoardsPatch)=>({
        ...state,
        initialBoards: {
            ...state.initialBoards,
            ...initialBoardsPatch
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff6d7c7bd67ca8f0$export$2e2bcd8739ae039 = (state = $ff6d7c7bd67ca8f0$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $2rxWW.SET_UP_CONTEXT:
            {
                const { boardsInLocation: boardsInLocation, ...rest } = action.payload;
                return {
                    ...state,
                    ...rest,
                    initialBoards: {
                        ...state.initialBoards,
                        ...boardsInLocation ? {
                            inLocation: boardsInLocation
                        } : Object.freeze({})
                    }
                };
            }
        case 0, $2rxWW.START_FETCHING_INITIAL_BOARDS:
            return $ff6d7c7bd67ca8f0$var$patchInitialBoards(state, {
                isInProgress: true,
                hasError: false
            });
        case 0, $2rxWW.INITIAL_BOARDS_FETCHED:
            {
                const { recentBoards: recentBoards, boardsInLocation: boardsInLocation } = action.payload;
                return $ff6d7c7bd67ca8f0$var$patchInitialBoards(state, {
                    recent: recentBoards,
                    hasError: false,
                    wereFetched: true,
                    isInProgress: false,
                    ...boardsInLocation ? {
                        inLocation: boardsInLocation
                    } : {}
                });
            }
        case 0, $2rxWW.INITIAL_BOARDS_FETCH_FAILURE:
            return $ff6d7c7bd67ca8f0$var$patchInitialBoards(state, {
                isInProgress: false,
                hasError: true
            });
        case 0, $2rxWW.SET_RECENTLY_CLICKED_ITEM:
            return {
                ...state,
                recentlyClickedItem: action.payload
            };
        case 0, $2rxWW.SEARCH_CHANGED:
            {
                const value = action.payload;
                return {
                    ...state,
                    searchValue: value,
                    isSearchInProgress: !!value.length,
                    hasSearchError: false,
                    shouldRetryLoadMore: false,
                    isLoadMoreInProgress: false,
                    searchResults: {
                        inLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList(),
                        notInLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList()
                    }
                };
            }
        case 0, $2rxWW.SEARCH_SUCCESS:
            {
                const { inLocation: inLocation, notInLocation: notInLocation } = action.payload;
                return {
                    ...state,
                    isSearchInProgress: false,
                    searchResults: {
                        inLocation: inLocation,
                        notInLocation: notInLocation
                    }
                };
            }
        case 0, $2rxWW.SEARCH_FAILURE:
            return {
                ...state,
                isSearchInProgress: false,
                hasSearchError: true
            };
        case 0, $2rxWW.LOAD_MORE:
            return {
                ...state,
                hasSearchError: false,
                isLoadMoreInProgress: true
            };
        case 0, $2rxWW.LOAD_MORE_SUCCESS:
            {
                const { values: values, total: total } = action.payload;
                const isSearchUsed = !!state.searchValue;
                const sourceValues = isSearchUsed ? state.searchResults : state.initialBoards;
                const mergedValues = [
                    ...sourceValues.inLocation.values,
                    ...values
                ];
                const uniqueValues = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(mergedValues, 'id');
                const results = {
                    ...sourceValues,
                    inLocation: {
                        values: uniqueValues,
                        total: total
                    }
                };
                const propName = isSearchUsed ? 'searchResults' : 'initialBoards';
                return {
                    ...state,
                    isLoadMoreInProgress: false,
                    shouldRetryLoadMore: false,
                    [propName]: results
                };
            }
        case 0, $2rxWW.LOAD_MORE_FAILURE:
            return {
                ...state,
                isLoadMoreInProgress: false,
                shouldRetryLoadMore: true
            };
        case 0, $2rxWW.FETCHED_BOARD_OWNER_ACCOUNT_ID:
            return {
                ...state,
                boardOwnerAccountId: action.payload
            };
        default:
            return state;
    }
};

});


parcelRegister("iMWMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda143c1c6fb22f6$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8lxl7 = parcelRequire("8lxl7");

var $bC2fB = parcelRequire("bC2fB");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");

var $Gyl50 = parcelRequire("Gyl50");

var $bu0aF = parcelRequire("bu0aF");
const $bda143c1c6fb22f6$var$mapStateToProps = (state)=>({
        boardsInLocation: (0, $Gyl50.getBoardsInLocation)(state),
        otherBoards: (0, $Gyl50.getOtherBoards)(state),
        selectedBoard: (0, $Gyl50.getSelectedBoard)(state),
        isLoading: (0, $1oWhI.isLoading)(state),
        isLoadingMore: (0, $1oWhI.isLoadingMore)(state),
        viewAllUrl: (0, $1oWhI.getViewAllUrl)(state),
        searchValue: (0, $1oWhI.getSearchValue)(state),
        isError: (0, $1oWhI.isError)(state),
        isSearchUsed: (0, $1oWhI.isSearchUsed)(state),
        hasShowMoreButton: (0, $Gyl50.hasShowMoreButton)(state),
        shouldRetryLoadMore: (0, $1oWhI.shouldRetryLoadMore)(state),
        remainingShowMoreBoards: (0, $Gyl50.getRemainingShowMoreBoards)(state)
    });
const $bda143c1c6fb22f6$var$mapDispatchToProps = (dispatch)=>({
        fetchInitialBoards: ()=>{
            dispatch((0, $2rxWW.fetchInitialBoards)());
        },
        searchBoards: (value)=>{
            dispatch((0, $2rxWW.changeSearch)(value));
        },
        loadMore: ()=>{
            dispatch((0, $2rxWW.loadMore)());
        },
        onClick: ({ isViewAll: isViewAll, key: key })=>{
            dispatch((0, $2rxWW.itemClicked)({
                isViewAll: !!isViewAll,
                id: key
            }));
        },
        onRetry: ()=>{
            dispatch((0, $2rxWW.retry)());
        }
    });
var $bda143c1c6fb22f6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8lxl7.default)((state)=>({
        attributes: {
            recentBoards: (0, $Gyl50.getRecentBoards)(state).length,
            boardsInLocation: (0, $Gyl50.getBoardsInLocation)(state).length,
            searchUsed: (0, $1oWhI.isSearchUsed)(state)
        }
    })), (0, $bC2fB.connect)($bda143c1c6fb22f6$var$mapStateToProps, $bda143c1c6fb22f6$var$mapDispatchToProps))(// @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Pick<Props, "intl" | "locationName" | "viewAllUrl" | "boardsInLocation" | "otherBoards"> & InexactPartial<Pick<Props, "isLoading" | "onClick" | "defaultOpen" | ... 13 more ... | "hasCreateBoardButton">> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<unknown>'. | Argument of type 'ComponentType<WithIntlProps<Pick<Props, "intl" | "viewAllUrl" | "boardsInLocation" | "locationName" | "otherBoards"> & InexactPartial<Pick<Props, "isLoading" | "onClick" | "searchValue" | ... 13 more ... | "hasCreateBoardButton">> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<unknown>'.
(0, $bu0aF.default));

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $daJ0i = parcelRequire("daJ0i");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


parcelRegister("Gyl50", function(module, exports) {

$parcel$export(module.exports, "getRecentBoards", () => $66b88e1dc4fa1893$export$bf57948c9c2c2673);
$parcel$export(module.exports, "getSelectedBoard", () => $66b88e1dc4fa1893$export$2789c573cd3f4849);
$parcel$export(module.exports, "getOtherBoards", () => $66b88e1dc4fa1893$export$10ebe9a8b9514a80);
$parcel$export(module.exports, "getBoardsInLocation", () => $66b88e1dc4fa1893$export$2ada7be29e6d80c3);
$parcel$export(module.exports, "getRemainingShowMoreBoards", () => $66b88e1dc4fa1893$export$774c7c0b6f4ac73f);
$parcel$export(module.exports, "hasShowMoreButton", () => $66b88e1dc4fa1893$export$a55a1a6294071229);

var $dGvGJ = parcelRequire("dGvGJ");


var $1oWhI = parcelRequire("1oWhI");
const $66b88e1dc4fa1893$export$bf57948c9c2c2673 = (0, $dGvGJ.createSelector)((0, $1oWhI.getRecentBoards), (0, $1oWhI.getBoardsInLocation), (recentBoards, boardsInLocation)=>{
    const isBoardIncluded = ({ id: id }, boards)=>boards.findIndex((board)=>board.id === id) !== -1;
    return recentBoards.filter((board)=>!isBoardIncluded(board, boardsInLocation));
});
const $66b88e1dc4fa1893$export$2789c573cd3f4849 = (state)=>(0, $1oWhI.getSelectedBoard)(state) || (0, $1oWhI.getRecentlyClickedBoard)(state);
const $66b88e1dc4fa1893$export$10ebe9a8b9514a80 = (state)=>{
    if ((0, $1oWhI.isSearchUsed)(state)) return (0, $1oWhI.getSearchResults)(state).notInLocation.values;
    return $66b88e1dc4fa1893$export$bf57948c9c2c2673(state);
};
const $66b88e1dc4fa1893$export$2ada7be29e6d80c3 = (state)=>{
    if ((0, $1oWhI.isSearchUsed)(state)) return (0, $1oWhI.getSearchResults)(state).inLocation.values;
    return (0, $1oWhI.getBoardsInLocation)(state);
};
const $66b88e1dc4fa1893$export$774c7c0b6f4ac73f = (state)=>{
    const { values: values, total: total } = (0, $1oWhI.isSearchUsed)(state) ? (0, $1oWhI.getSearchResults)(state).inLocation : (0, $1oWhI.getInitialBoardsProps)(state).inLocation;
    return Math.min(total - values.length, (0, $ab186e26e08820dd$export$b476a41a1b575909));
};
const $66b88e1dc4fa1893$export$a55a1a6294071229 = (state)=>$66b88e1dc4fa1893$export$774c7c0b6f4ac73f(state) > 0;

});

parcelRegister("bu0aF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f49de1b2ac0fb057$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6VJsU = parcelRequire("6VJsU");

var $dME4E = parcelRequire("dME4E");

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");

var $lXKEd = parcelRequire("lXKEd");

var $3vvFM = parcelRequire("3vvFM");

var $dymxi = parcelRequire("dymxi");

var $hjSul = parcelRequire("hjSul");

var $8aG9X = parcelRequire("8aG9X");
const $f49de1b2ac0fb057$var$before = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
        label: "",
        color: "currentColor"
    });
const $f49de1b2ac0fb057$var$transformBoardInLocation = (board)=>({
        text: board.name,
        key: board.id,
        before: $f49de1b2ac0fb057$var$before,
        url: board.url
    });
const $f49de1b2ac0fb057$var$transformBoardNotInLocation = (board, subText)=>({
        text: board.name,
        key: board.id,
        subText: subText,
        before: $f49de1b2ac0fb057$var$before,
        url: board.url
    });
const $f49de1b2ac0fb057$var$getLastLetter = (name)=>name ? name.toLowerCase().slice(-1) : '';
const $f49de1b2ac0fb057$var$SwitcherWithAnalytics = (0, $iQv12.default)((0, $lXKEd.default)('board'))((0, $3vvFM.default)); // eslint-disable-next-line jira/react/no-class-components
class $f49de1b2ac0fb057$export$985572cc065dac8f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isLocationUser: false,
            isLoading: false,
            isLoadingMore: false,
            isSearchUsed: false,
            isError: false,
            hasCreateBoardButton: false,
            hasShowMoreButton: false,
            remainingShowMoreBoards: 0,
            defaultOpen: false,
            selectedBoard: undefined,
            searchValue: '',
            fetchInitialBoards: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            searchBoards: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            loadMore: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCreateBoard: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getCreateLabel() {
        const { hasCreateBoardButton: hasCreateBoardButton, intl: { formatMessage: formatMessage } } = this.props;
        if (hasCreateBoardButton) return formatMessage((0, $8aG9X.default).createBoard);
        return undefined;
    }
    getBoardsInLocationLabel() {
        const { locationName: locationName, isLocationUser: isLocationUser, intl: { formatMessage: formatMessage } } = this.props;
        if (this.areBoardsInLocationEmpty()) return undefined;
        if (!isLocationUser) return formatMessage((0, $8aG9X.default).labelBoardsInProjectLocation, {
            locationName: locationName
        });
        return formatMessage((0, $8aG9X.default).labelBoardsInUserLocationNew, {
            locationName: locationName,
            lastLetter: $f49de1b2ac0fb057$var$getLastLetter(locationName)
        });
    }
    getOtherBoardLocationDescription(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { locationName: locationName, isLocationUser: isLocationUser } = board;
        if (!locationName) return '';
        if (!isLocationUser) return formatMessage((0, $8aG9X.default).projectLocationDescription, {
            location: board.locationName
        });
        return formatMessage((0, $8aG9X.default).userLocationDescriptionNew, {
            locationName: locationName,
            lastLetter: $f49de1b2ac0fb057$var$getLastLetter(locationName)
        });
    }
    getListHeading() {
        const { locationName: locationName, isSearchUsed: isSearchUsed, boardsInLocation: boardsInLocation, otherBoards: otherBoards, intl: { formatMessage: formatMessage } } = this.props;
        const areThereEmptySearchResults = isSearchUsed && !(boardsInLocation.length + otherBoards.length);
        if (areThereEmptySearchResults) return formatMessage((0, $8aG9X.default).searchNoMatchesFound);
        if (!isSearchUsed && this.areBoardsInLocationEmpty()) return formatMessage((0, $8aG9X.default).locationDoesNotHaveBoard, {
            location: locationName
        });
        return undefined;
    }
    areBoardsInLocationEmpty() {
        return this.props.boardsInLocation.length === 0;
    }
    createOptions() {
        const { boardsInLocation: boardsInLocation, otherBoards: otherBoards, hasShowMoreButton: hasShowMoreButton, isLoadingMore: isLoadingMore, remainingShowMoreBoards: remainingShowMoreBoards, intl: { formatMessage: formatMessage } } = this.props;
        const curriedTransformBoardNotInLocation = (board)=>$f49de1b2ac0fb057$var$transformBoardNotInLocation(board, this.getOtherBoardLocationDescription(board));
        const showMore = {
            isLoading: isLoadingMore,
            label: formatMessage((0, $8aG9X.default).showMore, {
                remainingBoards: remainingShowMoreBoards
            })
        };
        return [
            boardsInLocation.length && {
                label: this.getBoardsInLocationLabel(),
                options: boardsInLocation.map($f49de1b2ac0fb057$var$transformBoardInLocation),
                ...hasShowMoreButton ? {
                    showMore: showMore
                } : {}
            },
            otherBoards.length && {
                label: this.createHeaderLabel(),
                options: otherBoards.map(curriedTransformBoardNotInLocation)
            }
        ].filter(Boolean);
    }
    createViewAll() {
        const { intl: { formatMessage: formatMessage }, viewAllUrl: viewAllUrl } = this.props;
        return {
            withoutTopMargin: true,
            options: [
                {
                    text: formatMessage((0, $8aG9X.default).viewAllBoards),
                    key: '-1',
                    url: viewAllUrl,
                    isViewAll: true
                }
            ]
        };
    }
    createHeaderLabel() {
        const { intl: { formatMessage: formatMessage }, viewAllUrl: viewAllUrl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f49de1b2ac0fb057$var$GroupHeadingLabel, null, formatMessage((0, $8aG9X.default).otherRecentBoards)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            href: viewAllUrl,
            className: (0, $bwpsq.default)([
                "_kcon1kw7 _kq8jidpf _1laeidpf _1byqidpf"
            ])
        }, formatMessage((0, $8aG9X.default).viewAll)));
    }
    render() {
        const { selectedBoard: selectedBoard, defaultOpen: defaultOpen, isLoading: isLoading, isError: isError, onCreateBoard: onCreateBoard, onClick: onClick, onRetry: onRetry, searchValue: searchValue, loadMore: loadMore, intl: { formatMessage: formatMessage } } = this.props;
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dymxi.default), {
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6VJsU))),
            text: selectedBoard ? selectedBoard.name : formatMessage((0, $8aG9X.default).boards),
            subText: selectedBoard ? formatMessage((0, $8aG9X.default).board) : undefined
        }); // eslint-disable-next-line no-else-return
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f49de1b2ac0fb057$var$SwitcherWithAnalytics // @ts-expect-error - Type '({ showMore?: { isLoading: boolean; label: string; } | undefined; label: string | undefined; options: Item[]; } | { label: Element; options: Item[]; })[]' is not assignable to type 'ItemGroup[]'.
        , {
            items: this.createOptions(),
            isLoading: isLoading,
            selectedItem: selectedBoard ? $f49de1b2ac0fb057$var$transformBoardInLocation(selectedBoard) : undefined,
            createLabel: this.getCreateLabel(),
            searchValue: searchValue,
            searchPlaceholder: formatMessage((0, $8aG9X.default).searchPlaceholder),
            onClick: onClick,
            listHeading: this.getListHeading(),
            renderTrigger: this.renderTrigger,
            isDefaultOpen: defaultOpen,
            onOpenChange: this.onOpenChange,
            onCreate: onCreateBoard,
            isSearchEnabled: true,
            onSearchChange: this.onSearchChange,
            onRetry: onRetry,
            isError: isError,
            errorMessage: formatMessage((0, $8aG9X.default).errorMessage),
            onShowMore: loadMore
        });
    }
    constructor(...args){
        super(...args), this.onSearchChange = (value)=>{
            const { searchBoards: searchBoards, fetchInitialBoards: fetchInitialBoards } = this.props;
            if (value && value.length) searchBoards(value);
            else {
                searchBoards('');
                fetchInitialBoards();
            }
        }, this.onOpenChange = ({ isOpen: isOpen })=>{
            if (isOpen) this.props.fetchInitialBoards();
        }, this.renderTrigger = ({ isOpen: isOpen, targetRef: targetRef })=>{
            const { selectedBoard: selectedBoard, intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-test-id": "navigation-apps.scope-switcher-v2",
                "data-testid": "navigation-apps.scope-switcher-v2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dymxi.default), {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6VJsU))),
                text: selectedBoard ? selectedBoard.name : formatMessage((0, $8aG9X.default).boards),
                subText: selectedBoard ? formatMessage((0, $8aG9X.default).board) : undefined,
                isOpen: isOpen,
                targetRef: targetRef
            }));
        };
    }
}
var $f49de1b2ac0fb057$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($f49de1b2ac0fb057$export$985572cc065dac8f);
const $f49de1b2ac0fb057$var$GroupHeadingLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _u5f3u2gc _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $f49de1b2ac0fb057$var$linkStyles = null;

});
parcelRegister("6VJsU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbfaa58603b784789054dd0f73c52c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50bb556addc96d10$var$_react = $50bb556addc96d10$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $50bb556addc96d10$var$_appSwitcher = $50bb556addc96d10$var$_interopRequireDefault((parcelRequire("3fDjf")));

var $50bb556addc96d10$var$_switcher = $50bb556addc96d10$var$_interopRequireDefault((parcelRequire("3pAfJ")));
function $50bb556addc96d10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppSwitcherIcon.
 * This component is AppSwitcherIcon, with `UNSAFE_fallbackIcon` set to "SwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50bb556addc96d10$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $50bb556addc96d10$var$_react.default.createElement($50bb556addc96d10$var$_appSwitcher.default, Object.assign({
        LEGACY_fallbackIcon: $50bb556addc96d10$var$_switcher.default
    }, props));
$50bb556addc96d10$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
var $50bb556addc96d10$var$_default = module.exports.default = $50bb556addc96d10$var$AppSwitcherIcon;

});

parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("lXKEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f84629bca4dd45$export$2e2bcd8739ae039);

var $e4eHl = parcelRequire("e4eHl");

var $26Zd8 = parcelRequire("26Zd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01f84629bca4dd45$export$2e2bcd8739ae039 = (switcherType)=>{
    const camelCaseName = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(switcherType);
    const pascalCaseName = (0, (/*@__PURE__*/$parcel$interopDefault($26Zd8)))(camelCaseName);
    const onClick = ({ isViewAll: isViewAll }, sectionIndex)=>({
            name: camelCaseName,
            isViewAll: !!isViewAll,
            sectionIndex: sectionIndex
        });
    const onOpenChange = ({ isOpen: isOpen })=>({
            name: camelCaseName,
            isOpen: isOpen
        });
    const onClose = ({ closedWithoutInteracting: closedWithoutInteracting })=>({
            name: camelCaseName,
            closedWithoutInteracting: closedWithoutInteracting
        });
    const onSearchChange = (search)=>({
            name: camelCaseName,
            inputLength: search.length
        });
    return {
        onOpenChange: onOpenChange,
        onClose: onClose,
        onClick: onClick,
        onSearchChange: onSearchChange,
        onShowMore: `showMore${pascalCaseName}`,
        onCreate: `create${pascalCaseName}`,
        onRetry: `retry${pascalCaseName}`
    };
};

});

parcelRegister("3vvFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c763073d1299d22$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $fW7cr = parcelRequire("fW7cr");

var $8Rkzz = parcelRequire("8Rkzz");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $8oe80 = parcelRequire("8oe80");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");


var $4HmJy = parcelRequire("4HmJy");

var $dAYGO = parcelRequire("dAYGO");

var $bTOZt = parcelRequire("bTOZt");

var $48kqC = parcelRequire("48kqC");

var $6rDs9 = parcelRequire("6rDs9");

var $9dtoa = parcelRequire("9dtoa");

var $gzFa5 = parcelRequire("gzFa5");

var $15ZDY = parcelRequire("15ZDY");

var $bv5KO = parcelRequire("bv5KO");
const $2c763073d1299d22$var$createButtonHeight = 52; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2c763073d1299d22$var$isOptionSelected = (option, selected)=>selected && selected.length === 1 && option.key === selected[0].key;
const $2c763073d1299d22$var$filterOption = ()=>true;
class $2c763073d1299d22$export$e313913ef2c28083 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDefaultOpen: false,
            isLoading: false,
            isSearchEnabled: false,
            isError: false,
            items: undefined,
            createLabel: '',
            searchValue: '',
            searchPlaceholder: '',
            errorMessage: '',
            selectedItem: undefined,
            listHeading: undefined,
            onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSearchChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onShowMore: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        if (this.props.isDefaultOpen) this.onOpen();
    }
    componentDidUpdate(prevProps) {
        // UI code
        const { searchValue: searchValue } = this.props;
        if (prevProps.searchValue !== searchValue) // this is guarded, so it's legit
        this.setState({
            searchValue: searchValue
        });
         // Analytics code
        if (this.state.isOpen) {
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.hasBoardSwitcherBeenOpened.current = true;
            if (!this.prevSwitcherOpenStateRef.current) {
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.hasUserInteractedWithSwitcherViaClickRef.current = null; // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.hasUserInteractedWithSwitcherViaEnterKeyDownRef.current = null;
            }
        } else // eslint-disable-next-line no-lonely-if
        if (!this.hasUserInteractedWithSwitcherViaClickRef.current && !this.hasUserInteractedWithSwitcherViaEnterKeyDownRef.current && this.hasBoardSwitcherBeenOpened.current) this.props.onClose({
            closedWithoutInteracting: true
        });
         // Analytics code
        // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
        this.prevSwitcherOpenStateRef.current = this.state.isOpen;
    }
    onOpenChange({ isOpen: isOpen }) {
        if (this.state.isOpen === isOpen) return;
        this.setState({
            isOpen: isOpen,
            lastMenuHeight: null
        });
        this.props.onOpenChange({
            isOpen: isOpen
        });
    }
    getMenuHeight() {
        return this.isCreateButtonAvailable() ? $2c763073d1299d22$var$menuHeight - $2c763073d1299d22$var$createButtonHeight : $2c763073d1299d22$var$menuHeight;
    }
    getLoadingHeight() {
        const { lastMenuHeight: lastMenuHeight } = this.state;
        if (lastMenuHeight) return lastMenuHeight;
        return this.getMenuHeight() - (0, $4HmJy.controlHeight);
    }
    closeSwitcher() {
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.popupRef.current && this.popupRef.current.close();
    }
    isCreateButtonAvailable() {
        return !!this.props.createLabel;
    }
    popperProps() {
        const placement = 'bottom-start';
        return {
            placement: placement,
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 5,
                        mainAxis: false // true by default
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            (0, $gwIPs.gridSize)
                        ]
                    }
                },
                {
                    name: 'hide',
                    options: {
                        padding: 5
                    }
                },
                {
                    name: 'flip',
                    options: {
                        padding: 5
                    }
                }
            ]
        };
    }
    renderFooter() {
        const { createLabel: createLabel } = this.props;
        return this.isCreateButtonAvailable() && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTOZt.default), {
            label: createLabel,
            onClick: this.onCreate
        });
    }
    render() {
        const { isLoading: isLoading, selectedItem: selectedItem, items: items, renderTrigger: renderTrigger, onMouseEnter: onMouseEnter } = this.props;
        const { isOpen: isOpen, searchValue: searchValue, triggerWidth: triggerWidth } = this.state;
        const onFocus = (onFocusProps, defaultOptions)=>{
            const { focused: focused } = onFocusProps;
            const isOptionFocused = (option)=>option.text === focused.text;
            const groupData = defaultOptions?.find((option)=>option.options?.some(isOptionFocused));
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            return `Option ${this.getOptionLabel(focused)}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
        }; // Helper function which identifies if options are grouped.
        const isOptionsGrouped = (arr)=>arr?.every((obj)=>Object.hasOwn(obj, 'options')); // @ts-expect-error - TS7031 - Binding element 'ref' implicitly has an 'any' type.
        const createTriggerRenderer = ({ ref: ref })=>renderTrigger({
                isOpen: isOpen,
                onMouseEnter: onMouseEnter,
                targetRef: ref
            });
        const renderPopupSelect = ()=>// @ts-expect-error - TS2769 - No overload matches this call.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
                ref: this.popupRef,
                onOpen: this.onOpen,
                onClose: this.onClose,
                autoFocus: true,
                maxMenuWidth: triggerWidth,
                minMenuWidth: triggerWidth,
                backspaceRemovesValue: false,
                classNamePrefix: "switcher",
                components: {
                    Control: this.renderControl,
                    Input: this.renderInput,
                    DropdownIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    Placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    IndicatorsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    LoadingIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    Option: $bv5KO.default,
                    Menu: this.renderMenu,
                    Group: this.renderGroup,
                    GroupHeading: this.renderGroupHeading,
                    MenuList: this.renderMenuList,
                    LoadingMessage: this.renderLoading,
                    NoOptionsMessage: this.renderLoading
                },
                getOptionLabel: this.getOptionLabel,
                controlShouldRenderValue: false,
                isLoading: isLoading,
                isClearable: false,
                searchThreshold: -1,
                isOptionSelected: $2c763073d1299d22$var$isOptionSelected,
                inputValue: searchValue,
                menuIsOpen: true // react-select does not respect 'isLoading' parameter in not async version
                ,
                // that's why we use NoOptionsMessage to display loading state
                // as we'll always have at least one option - view all link
                options: isLoading || !items ? [] : items,
                maxMenuHeight: this.getMenuHeight(),
                onChange: this.onSelectChange,
                filterOption: $2c763073d1299d22$var$filterOption,
                styles: $2c763073d1299d22$var$selectStyles(),
                tabSelectsValue: false,
                value: selectedItem,
                footer: this.renderFooter(),
                target: createTriggerRenderer,
                popperProps: this.popperProps(),
                defaultIsOpen: this.props.isDefaultOpen,
                ariaLiveMessages: isOptionsGrouped(this.props.items) ? {
                    onFocus: (data)=>onFocus(data, this.props.items)
                } : undefined
            });
        return(// In styled there is used a z-index hack to increase z-index
        // value of components inside SwitcherContainer. More info
        // in styled file
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c763073d1299d22$var$SwitcherContainer, {
            ref: this.switcherRef,
            onClick: this.onClick,
            onKeyDown: this.onKeyDown
        }, renderPopupSelect()));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.isDefaultOpen,
            lastMenuHeight: null,
            searchValue: this.props.searchValue,
            triggerWidth: (0, $gwIPs.gridSize) * 26
        }, // These refs store whether the user has interacted with the switcher or any of its child components
        // via recording whether an onClick or onKeyDown 'Enter' event occurred.
        // These refs are used to measure the analytics of when this component was opened, and then closed without
        // being used.
        // Click and KeyDown must be separated since onClick is called when create a board action is rendered via
        // the Enter key (accessibility usage)
        this.hasBoardSwitcherBeenOpened = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.hasUserInteractedWithSwitcherViaClickRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.prevSwitcherOpenStateRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.hasUserInteractedWithSwitcherViaEnterKeyDownRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.onSearchChange = (value)=>{
            if (value.length) this.debouncedOnChange(value);
            else {
                this.debouncedOnChange.cancel();
                this.props.onSearchChange(value);
            }
            this.setState({
                searchValue: value
            });
        }, this.onOpen = ()=>{
            this.onOpenChange({
                isOpen: true
            });
            if (this.switcherRef.current) {
                const { width: width } = this.switcherRef.current.getBoundingClientRect();
                this.setState({
                    triggerWidth: width
                });
            }
        }, this.onClose = ()=>{
            this.onOpenChange({
                isOpen: false
            });
        }, this.onSelectChange = (value)=>{
            const section = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(this.props.items, (itemsGroup)=>itemsGroup.options.includes(value));
            this.props.onClick(value, section);
        }, this.onBeforeLoading = ({ height: height })=>{
            this.setState({
                lastMenuHeight: height
            });
        }, this.onCreate = ()=>{
            this.props.onCreate();
            this.closeSwitcher();
        }, this.onClick = ()=>{
            // Analytics code
            // This does not represent a user interaction, so ignore it if the ref has not been initialized
            if (this.hasUserInteractedWithSwitcherViaClickRef.current === null) {
                // Initialize the ref to pick up user interactions
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.hasUserInteractedWithSwitcherViaClickRef.current = false;
                return;
            } // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.hasUserInteractedWithSwitcherViaClickRef.current = true;
        }, this.onKeyDown = (event)=>{
            // Analytics code
            if (event.key === 'Enter' && this.hasUserInteractedWithSwitcherViaClickRef.current !== null) // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.hasUserInteractedWithSwitcherViaEnterKeyDownRef.current = true;
        }, this.switcherRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.popupRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.debouncedOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.props.onSearchChange, (0, $58a8cc6dba6ea954$export$8bd078c872bc40fb)), this.renderLoading = ()=>this.props.isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dtoa.default), {
                height: this.getLoadingHeight()
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.renderMenuList = (props)=>{
            const { isError: isError, errorMessage: errorMessage, onRetry: onRetry, listHeading: listHeading } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzFa5.default), {
                ...props,
                isError: isError,
                errorMessage: errorMessage,
                listHeading: listHeading,
                onBeforeLoading: this.onBeforeLoading,
                onRetry: onRetry
            });
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.renderGroupHeading = (props)=>{
            const { children: children, data: data } = props; // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { formatMessage: formatMessage } = (0, $koVbs.default)();
            const ariaLabel = children && children[0] ? data?.label : formatMessage((0, $15ZDY.default).otherRecentBoards);
            return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).GroupHeading, {
                ...props,
                role: "group",
                "aria-label": ariaLabel
            }) : null;
        }, this.renderControl = (selectControlProps)=>{
            const { isSearchEnabled: isSearchEnabled } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAYGO.default), {
                isSearchEnabled: isSearchEnabled,
                ...selectControlProps
            });
        }, this.renderInput = (selectInputProps)=>{
            const { searchPlaceholder: searchPlaceholder } = this.props;
            const { searchValue: searchValue } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6rDs9.default), {
                onChange: this.onSearchChange,
                value: searchValue,
                placeholder: searchPlaceholder,
                inputProps: selectInputProps
            });
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.renderGroup = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $48kqC.default), {
                ...props,
                onShowMore: this.props.onShowMore
            }), this.renderMenu = (props)=>{
            const { innerRef: innerRef, innerProps: innerProps, children: children } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: innerRef,
                ...innerProps
            }, children);
        }, this.getOptionLabel = (option)=>{
            let label = option.text;
            if (option.subText) label += ` ${option.subText}`;
            return label;
        };
    }
}
var $2c763073d1299d22$export$2e2bcd8739ae039 // This is z-index hack for the navigation
 = (0, $8oe80.default)('switcherMenu', {
    onClick: 'clicked',
    onOpenChange: 'opened',
    onClose: 'closed',
    onCreate: 'clicked',
    onRetry: 'clicked',
    onSearchChange: 'typed',
    onShowMore: 'clicked'
})($2c763073d1299d22$export$e313913ef2c28083);
// In navigation there are some items which are positioned using `z-index`
// and value is the same as popup select
// https://jdog.jira-dev.com/browse/KITKAT-936
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2c763073d1299d22$var$SwitcherContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1gn7zo7u",
            __cmplp.className
        ])
    });
});
const $2c763073d1299d22$var$menuHeight = 53 * (0, $gwIPs.gridSize);
const $2c763073d1299d22$var$selectStyles = ()=>({
        valueContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        menu: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        groupHeading: (defaultStyles)=>({
                ...defaultStyles,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)",
                marginBottom: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                position: 'sticky',
                top: 0,
                zIndex: 2,
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                display: 'flex',
                flexDirection: 'row',
                '&&&': {
                    width: 'inherit',
                    display: 'flex'
                }
            }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        group: (defaultStyles)=>({
                ...defaultStyles,
                paddingTop: 0,
                paddingBottom: 0
            }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        menuList: (defaultStyles)=>({
                ...defaultStyles,
                zIndex: 1,
                position: 'relative',
                paddingTop: 0,
                paddingBottom: 0
            })
    });

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});

parcelRegister("bChGW", function(module, exports) {

$parcel$export(module.exports, "components", () => $ea75c1778b4e3ad2$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $ea75c1778b4e3ad2$export$71abc632aa29e6fe);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $95iuW.ClearIndicator),
    Control: (0, $eZFhY.default),
    DropdownIndicator: (0, $95iuW.DropdownIndicator),
    Group: (0, $i48X9.default),
    GroupHeading: (0, $i48X9.GroupHeading),
    IndicatorsContainer: (0, $h1QWG.IndicatorsContainer),
    Input: (0, $dS5G5.default),
    LoadingIndicator: (0, $95iuW.LoadingIndicator),
    Menu: (0, $aA8TC.default),
    MenuList: (0, $aA8TC.MenuList),
    MenuPortal: (0, $aA8TC.MenuPortal),
    LoadingMessage: (0, $aA8TC.LoadingMessage),
    NoOptionsMessage: (0, $aA8TC.NoOptionsMessage),
    MultiValue: (0, $hqcPo.default),
    MultiValueContainer: (0, $hqcPo.MultiValueContainer),
    MultiValueLabel: (0, $hqcPo.MultiValueLabel),
    MultiValueRemove: (0, $hqcPo.MultiValueRemove),
    Option: (0, $8l2RA.default),
    Placeholder: (0, $kKm82.default),
    SelectContainer: (0, $h1QWG.SelectContainer),
    SingleValue: (0, $hpcbi.default),
    ValueContainer: (0, $h1QWG.ValueContainer)
};
const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
        ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("h1QWG", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $78186faf13ea75d3$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $78186faf13ea75d3$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $78186faf13ea75d3$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $78186faf13ea75d3$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $78186faf13ea75d3$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $78186faf13ea75d3$export$d0ffd7e649cab6f);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $agFN9 = parcelRequire("agFN9");

var $1dm34 = parcelRequire("1dm34");
const $78186faf13ea75d3$export$949392aeaf7d2e3a = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.containerCSS)() : (0, $1dm34.containerCSS)(props);
const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.SelectContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.SelectContainer), {
        ...props
    });
const $78186faf13ea75d3$export$47aec73c7aa6b9aa = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.valueContainerCSS)() : (0, $1dm34.valueContainerCSS)(props);
const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.ValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.ValueContainer), {
        ...props
    });
const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.indicatorsContainerCSS)() : (0, $1dm34.indicatorsContainerCSS)();
const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.IndicatorsContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.IndicatorsContainer), {
        ...props
    });

});
parcelRegister("agFN9", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $0e7e14a3e3f4b78e$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
const $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a = ()=>({});
const $0e7e14a3e3f4b78e$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
const $0e7e14a3e3f4b78e$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $gyjU7.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$containerStyles.default,
            isRtl && $0e7e14a3e3f4b78e$var$containerStyles.rtl,
            isDisabled && $0e7e14a3e3f4b78e$var$containerStyles.disabled,
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $0e7e14a3e3f4b78e$var$containerStyles.ff_safari_input_fix,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa = ()=>({});
const $0e7e14a3e3f4b78e$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7"
};
const $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $0e7e14a3e3f4b78e$var$valueContainerStyles.flex,
            isCompact && $0e7e14a3e3f4b78e$var$valueContainerStyles.compact,
            (0, $DEWI6.cx)(className || 'value-container', xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7 = ()=>({});
const $0e7e14a3e3f4b78e$var$indicatorContainerStyles = null;
const $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("gyjU7", function(module, exports) {

$parcel$export(module.exports, "noop", () => $109d3f9af5469308$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $109d3f9af5469308$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $109d3f9af5469308$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $109d3f9af5469308$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $109d3f9af5469308$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $109d3f9af5469308$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $109d3f9af5469308$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $109d3f9af5469308$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $109d3f9af5469308$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $109d3f9af5469308$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $109d3f9af5469308$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $109d3f9af5469308$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $109d3f9af5469308$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $109d3f9af5469308$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $109d3f9af5469308$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $109d3f9af5469308$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $109d3f9af5469308$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $109d3f9af5469308$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $109d3f9af5469308$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $109d3f9af5469308$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $109d3f9af5469308$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $109d3f9af5469308$export$4213b25a1c4e877);
const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
    if ($109d3f9af5469308$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $109d3f9af5469308$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $109d3f9af5469308$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
    const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
        $109d3f9af5469308$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $109d3f9af5469308$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $109d3f9af5469308$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $109d3f9af5469308$var$passiveOptionAccessed = false;
const $109d3f9af5469308$var$options = {
    get passive () {
        return $109d3f9af5469308$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
}
const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $109d3f9af5469308$var$isArray(arg) {
    return Array.isArray(arg);
}
function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("1dm34", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $cefbf12e841cc8e0$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $cefbf12e841cc8e0$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $cefbf12e841cc8e0$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $cefbf12e841cc8e0$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $cefbf12e841cc8e0$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $cefbf12e841cc8e0$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $gyjU7 = parcelRequire("gyjU7");
const $cefbf12e841cc8e0$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $h9kUS.media).above.xs}`]: {
            font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $cefbf12e841cc8e0$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $cefbf12e841cc8e0$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $cefbf12e841cc8e0$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $cefbf12e841cc8e0$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $cefbf12e841cc8e0$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});


parcelRegister("eZFhY", function(module, exports) {

$parcel$export(module.exports, "css", () => $728816cb4150b6bc$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $728816cb4150b6bc$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8JQpT = parcelRequire("8JQpT");

var $PQCB3 = parcelRequire("PQCB3");
const $728816cb4150b6bc$export$dbf350e5966cf602 = (props)=>{
    return (0, $VSDnB.fg)('compiled-react-select') ? (0, $8JQpT.css)() : (0, $PQCB3.css)(props);
};
const $728816cb4150b6bc$var$Control = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JQpT.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PQCB3.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;

});
parcelRegister("8JQpT", function(module, exports) {

$parcel$export(module.exports, "css", () => $2fb743295de83222$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $2fb743295de83222$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $2fb743295de83222$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _jqf6y3o9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $2fb743295de83222$export$dbf350e5966cf602 = ()=>({});
const $2fb743295de83222$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $2fb743295de83222$var$styles.default,
            isDisabled && $2fb743295de83222$var$styles.disabled,
            isInvalid && $2fb743295de83222$var$styles.invalid,
            isCompact && $2fb743295de83222$var$styles.compact,
            appearance === 'subtle' && $2fb743295de83222$var$styles.subtle,
            appearance === 'subtle' && isFocused && $2fb743295de83222$var$styles.subtleFocused,
            isFocused && $2fb743295de83222$var$styles.focused,
            appearance === 'none' && $2fb743295de83222$var$styles.none,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2fb743295de83222$export$2e2bcd8739ae039 = $2fb743295de83222$var$Control;

});

parcelRegister("PQCB3", function(module, exports) {

$parcel$export(module.exports, "css", () => $00e6c98a997351d1$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $00e6c98a997351d1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $00e6c98a997351d1$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $00e6c98a997351d1$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $gyjU7.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$00e6c98a997351d1$export$2e2bcd8739ae039 = $00e6c98a997351d1$var$Control;

});


parcelRegister("i48X9", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $902e86f4b4fe337b$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $902e86f4b4fe337b$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $902e86f4b4fe337b$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $902e86f4b4fe337b$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $OON7h = parcelRequire("OON7h");

var $2Tqqx = parcelRequire("2Tqqx");
const $902e86f4b4fe337b$export$b6794329c1460634 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $OON7h.groupCSS)() : (0, $2Tqqx.groupCSS)(props);
const $902e86f4b4fe337b$var$Group = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Tqqx.default), {
        ...props
    });
const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $OON7h.groupHeadingCSS)() : (0, $2Tqqx.groupHeadingCSS)(props);
const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.GroupHeading), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Tqqx.GroupHeading), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;

});
parcelRegister("OON7h", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $a3ce5541021fbdcc$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $a3ce5541021fbdcc$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $a3ce5541021fbdcc$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $a3ce5541021fbdcc$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $a3ce5541021fbdcc$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $a3ce5541021fbdcc$export$b6794329c1460634 = ()=>({});
const $a3ce5541021fbdcc$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a3ce5541021fbdcc$var$styles.root,
            (0, $DEWI6.cx)(className, xcss, innerProps?.className)
        ]),
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                children: children
            })
        ]
    });
};
const $a3ce5541021fbdcc$var$headingStyles = null;
const $a3ce5541021fbdcc$export$e5a7fbb542efcb7d = ()=>({});
const $a3ce5541021fbdcc$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _jqf6dpkn _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ce5541021fbdcc$export$2e2bcd8739ae039 = $a3ce5541021fbdcc$var$Group;

});

parcelRegister("2Tqqx", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $460363aae382b65a$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $460363aae382b65a$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $460363aae382b65a$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $460363aae382b65a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $460363aae382b65a$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $460363aae382b65a$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, label && /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $460363aae382b65a$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $460363aae382b65a$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$460363aae382b65a$export$2e2bcd8739ae039 = $460363aae382b65a$var$Group;

});


parcelRegister("95iuW", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $13f090f36c42825d$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $13f090f36c42825d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $13f090f36c42825d$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $13f090f36c42825d$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $13f090f36c42825d$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $13f090f36c42825d$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7FTuF = parcelRequire("7FTuF");

var $ckNeS = parcelRequire("ckNeS");
const $13f090f36c42825d$export$e1687335805e1230 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.dropdownIndicatorCSS)() : (0, $ckNeS.dropdownIndicatorCSS)(props);
const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.DropdownIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.DropdownIndicator), {
        ...props
    });
const $13f090f36c42825d$export$9c0419fd944c1def = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.clearIndicatorCSS)() : (0, $ckNeS.clearIndicatorCSS)(props);
const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.ClearIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.ClearIndicator), {
        ...props
    });
const $13f090f36c42825d$export$1d3f24cde248e6b5 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.loadingIndicatorCSS)() : (0, $ckNeS.loadingIndicatorCSS)(props);
const $13f090f36c42825d$export$7c20be4c1d342248 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.LoadingIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.LoadingIndicator), {
        ...props
    });

});
parcelRegister("7FTuF", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $a7cf25f9e9baf2e9$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $a7cf25f9e9baf2e9$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $a7cf25f9e9baf2e9$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $c8Oei = parcelRequire("c8Oei");

var $cQz2U = parcelRequire("cQz2U");

var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $a7cf25f9e9baf2e9$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $a7cf25f9e9baf2e9$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
const $a7cf25f9e9baf2e9$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $a7cf25f9e9baf2e9$export$e1687335805e1230 = ()=>({});
const $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$dropdownStyles.default,
            isDisabled && $a7cf25f9e9baf2e9$var$dropdownStyles.disabled,
            isCompact && $a7cf25f9e9baf2e9$var$dropdownStyles.compact,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "span",
            xcss: $a7cf25f9e9baf2e9$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$9c0419fd944c1def = ()=>({});
const $a7cf25f9e9baf2e9$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$clearIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$clearIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            xcss: $a7cf25f9e9baf2e9$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5 = ()=>({});
const $a7cf25f9e9baf2e9$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            size: "small"
        })
    });
};

});
parcelRegister("cQz2U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7da2857c3151a92889bed61f5baa1334>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));

var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
function $95a586bfe482ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
    }, props));
$95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;

});
parcelRegister("47etd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23b3104937a360e799abf4f0ea698b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ff30a5d9a7d32b6$var$_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;

});

parcelRegister("673MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
function $473654f205f53fc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $473654f205f53fc4$var$SelectClearIcon = (props)=>/*#__PURE__*/ $473654f205f53fc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $473654f205f53fc4$var$_crossCircle.default
    }));
$473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;

});



parcelRegister("ckNeS", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $fbe9e11ad0f07d66$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $fbe9e11ad0f07d66$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $fbe9e11ad0f07d66$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $fbe9e11ad0f07d66$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $fbe9e11ad0f07d66$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $fbe9e11ad0f07d66$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $c8Oei = parcelRequire("c8Oei");

var $cQz2U = parcelRequire("cQz2U");

var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $fbe9e11ad0f07d66$var$iconContainerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $fbe9e11ad0f07d66$var$dropdownWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.075'
});
const $fbe9e11ad0f07d66$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $fbe9e11ad0f07d66$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        as: "span",
        xcss: $fbe9e11ad0f07d66$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
};
const $fbe9e11ad0f07d66$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $fbe9e11ad0f07d66$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
        xcss: $fbe9e11ad0f07d66$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $fbe9e11ad0f07d66$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $fbe9e11ad0f07d66$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
        size: "small"
    }));
};

});


parcelRegister("dS5G5", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $1c949ac6f5985b40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $1c949ac6f5985b40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dIuKO = parcelRequire("dIuKO");

var $2KDs7 = parcelRequire("2KDs7");
const $1c949ac6f5985b40$export$14a7781d0ca7abea = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $dIuKO.inputCSS)() : (0, $2KDs7.inputCSS)(props);
const $1c949ac6f5985b40$var$Input = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dIuKO.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2KDs7.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;

});
parcelRegister("dIuKO", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $6599751c7dd5cc6c$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $6599751c7dd5cc6c$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $6599751c7dd5cc6c$export$14a7781d0ca7abea = ()=>({});
const $6599751c7dd5cc6c$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $6599751c7dd5cc6c$var$nativeInnputStyles = null;
const $6599751c7dd5cc6c$var$hidden = null;
const $6599751c7dd5cc6c$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'input', {
        'input-container': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $6599751c7dd5cc6c$var$inputStyles.root,
            isDisabled && $6599751c7dd5cc6c$var$inputStyles.disabled,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName)
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6599751c7dd5cc6c$export$2e2bcd8739ae039 = $6599751c7dd5cc6c$var$Input;

});

parcelRegister("2KDs7", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $3bbb27dfa42e66e5$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $3bbb27dfa42e66e5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $3bbb27dfa42e66e5$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$3bbb27dfa42e66e5$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $3bbb27dfa42e66e5$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $3bbb27dfa42e66e5$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$3bbb27dfa42e66e5$var$spacingStyle
    }
};
const $3bbb27dfa42e66e5$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$3bbb27dfa42e66e5$var$spacingStyle
    });
const $3bbb27dfa42e66e5$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $3bbb27dfa42e66e5$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bbb27dfa42e66e5$export$2e2bcd8739ae039 = $3bbb27dfa42e66e5$var$Input;

});


parcelRegister("aA8TC", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $1fde8cb844828ae2$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $1fde8cb844828ae2$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $1fde8cb844828ae2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $1fde8cb844828ae2$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $1fde8cb844828ae2$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $1fde8cb844828ae2$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $1fde8cb844828ae2$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $1fde8cb844828ae2$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $1fde8cb844828ae2$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $1fde8cb844828ae2$export$793392f970497feb);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $5aZmi = parcelRequire("5aZmi");

var $1s63F = parcelRequire("1s63F");
const $1fde8cb844828ae2$export$a228922d5ca42a79 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuCSS)() : (0, $1s63F.menuCSS)(props);
const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPlacer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuPlacer), {
        ...props
    });
const $1fde8cb844828ae2$var$Menu = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
const $1fde8cb844828ae2$export$abafed69cff95d5e = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuListCSS)() : (0, $1s63F.menuListCSS)(props);
const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuList), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuList), {
        ...props
    });
// ==============================
// Menu Notices
// ==============================
const $1fde8cb844828ae2$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$d58b72b7d3c4072c = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.NoOptionsMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.NoOptionsMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$e928a71d039d3102 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.LoadingMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.LoadingMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuPortalCSS)() : (0, $1s63F.menuPortalCSS)(props);
const $1fde8cb844828ae2$export$793392f970497feb = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPortal), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuPortal), {
        ...props
    });

});
parcelRegister("5aZmi", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $76c1fc1d7ab61474$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $76c1fc1d7ab61474$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $76c1fc1d7ab61474$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $76c1fc1d7ab61474$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $76c1fc1d7ab61474$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $76c1fc1d7ab61474$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $76c1fc1d7ab61474$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $76c1fc1d7ab61474$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $VSDnB = parcelRequire("VSDnB");

var $dS3PR = parcelRequire("dS3PR");

var $gyjU7 = parcelRequire("gyjU7");
function $76c1fc1d7ab61474$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $VSDnB.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $76c1fc1d7ab61474$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $76c1fc1d7ab61474$var$menuStyles = {
    root: "_2rkoglpi _jqf689mz _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qs17uf",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
const $76c1fc1d7ab61474$export$a228922d5ca42a79 = ()=>({});
const $76c1fc1d7ab61474$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $76c1fc1d7ab61474$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($76c1fc1d7ab61474$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $76c1fc1d7ab61474$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $76c1fc1d7ab61474$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $76c1fc1d7ab61474$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $76c1fc1d7ab61474$var$menuStyles.root,
            $76c1fc1d7ab61474$var$menuStyles[placement],
            (0, $DEWI6.cx)(xcss, className)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$76c1fc1d7ab61474$export$2e2bcd8739ae039 = $76c1fc1d7ab61474$var$Menu;
const $76c1fc1d7ab61474$export$abafed69cff95d5e = ()=>({});
const $76c1fc1d7ab61474$var$menuListStyles = null;
const $76c1fc1d7ab61474$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
// ==============================
// Menu Notices
// ==============================
const $76c1fc1d7ab61474$var$noticeCSS = ()=>({});
const $76c1fc1d7ab61474$var$noticeStyles = null;
const $76c1fc1d7ab61474$export$cf0e22534d8b0074 = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$98ec46397a8cb3cd = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9 = ()=>({});
const $76c1fc1d7ab61474$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($76c1fc1d7ab61474$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $DEWI6.cx)(className, xcss),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            zIndex: 9999,
            left: computedPosition.rect.left,
            position: menuPosition,
            top: computedPosition.offset,
            width: computedPosition.rect.width,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($76c1fc1d7ab61474$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});


parcelRegister("1s63F", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $b0d3f8517e4be892$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $b0d3f8517e4be892$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $b0d3f8517e4be892$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $b0d3f8517e4be892$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $b0d3f8517e4be892$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $b0d3f8517e4be892$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $b0d3f8517e4be892$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $b0d3f8517e4be892$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $b0d3f8517e4be892$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $gyjU7 = parcelRequire("gyjU7");
function $b0d3f8517e4be892$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $VSDnB.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $b0d3f8517e4be892$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $b0d3f8517e4be892$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b0d3f8517e4be892$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$b0d3f8517e4be892$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $b0d3f8517e4be892$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b0d3f8517e4be892$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($b0d3f8517e4be892$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $b0d3f8517e4be892$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $b0d3f8517e4be892$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $b0d3f8517e4be892$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b0d3f8517e4be892$export$2e2bcd8739ae039 = $b0d3f8517e4be892$var$Menu;
const $b0d3f8517e4be892$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $b0d3f8517e4be892$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $b0d3f8517e4be892$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $b0d3f8517e4be892$export$cf0e22534d8b0074 = $b0d3f8517e4be892$var$noticeCSS;
const $b0d3f8517e4be892$export$98ec46397a8cb3cd = $b0d3f8517e4be892$var$noticeCSS;
const $b0d3f8517e4be892$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $b0d3f8517e4be892$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $b0d3f8517e4be892$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $b0d3f8517e4be892$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($b0d3f8517e4be892$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $gyjU7.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($b0d3f8517e4be892$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});


parcelRegister("hqcPo", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $20933ad7b05a0c37$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $20933ad7b05a0c37$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $20933ad7b05a0c37$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $20933ad7b05a0c37$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $20933ad7b05a0c37$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $20933ad7b05a0c37$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $iBgL9 = parcelRequire("iBgL9");

var $4ntXy = parcelRequire("4ntXy");
const $20933ad7b05a0c37$export$23c213f7717186af = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueCSS)() : (0, $4ntXy.multiValueCSS)(props);
const $20933ad7b05a0c37$export$f40612612e0af964 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueLabelCSS)() : (0, $4ntXy.multiValueLabelCSS)(props);
const $20933ad7b05a0c37$export$283467f6c4ac142b = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueRemoveCSS)() : (0, $4ntXy.multiValueRemoveCSS)(props);
const $20933ad7b05a0c37$export$cf9cf2a30a59265c = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueContainer), {
        ...props
    });
const $20933ad7b05a0c37$export$544aeea2a5ce08ee = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueLabel), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueLabel), {
        ...props
    });
function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a(props) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    (0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueRemove), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueRemove), {
        ...props
    }));
}
const $20933ad7b05a0c37$var$MultiValue = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;

});
parcelRegister("iBgL9", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $a2bd6c7425e95809$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $a2bd6c7425e95809$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $a2bd6c7425e95809$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $a2bd6c7425e95809$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $a2bd6c7425e95809$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $a2bd6c7425e95809$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $673MF = parcelRequire("673MF");

var $bjGSs = parcelRequire("bjGSs");

var $VSDnB = parcelRequire("VSDnB");

var $c0aEF = parcelRequire("c0aEF");

var $gyjU7 = parcelRequire("gyjU7");
const $a2bd6c7425e95809$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs17si _1aewe4h9 _6up53acm _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
const $a2bd6c7425e95809$export$23c213f7717186af = ()=>({});
const $a2bd6c7425e95809$export$f40612612e0af964 = ()=>({});
const $a2bd6c7425e95809$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
const $a2bd6c7425e95809$export$283467f6c4ac142b = ()=>({});
const $a2bd6c7425e95809$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rkoglpi _bfhk1w7a _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
const $a2bd6c7425e95809$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueStyles.disabled,
            isFocused && $a2bd6c7425e95809$var$multiValueStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueStyles.refresh,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueLabelStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueLabelStyles.disabled,
            hasEllipsis && $a2bd6c7425e95809$var$multiValueLabelStyles.ellipsis,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueLabelStyles.refresh,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$var$disabledStyles = null;
const $a2bd6c7425e95809$var$enabledStyles = null;
const $a2bd6c7425e95809$var$iconWrapperStyles = {
    root: "_ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $a2bd6c7425e95809$var$renderIcon = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
        label: "",
        color: "currentColor"
    });
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
        xcss: $a2bd6c7425e95809$var$iconWrapperStyles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
            label: "",
            color: "currentColor"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($673MF))), {
        label: "",
        primaryColor: "transparent",
        size: "small",
        secondaryColor: "inherit"
    });
};
function $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueRemoveStyles.root,
            isFocused && $a2bd6c7425e95809$var$multiValueRemoveStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueRemoveStyles.refresh,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $bwpsq.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: $a2bd6c7425e95809$var$renderIcon()
        })
    });
}
const $a2bd6c7425e95809$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a2bd6c7425e95809$export$2e2bcd8739ae039 = $a2bd6c7425e95809$var$MultiValue;

});

parcelRegister("4ntXy", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $e8473c8c41411b48$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $e8473c8c41411b48$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $e8473c8c41411b48$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $e8473c8c41411b48$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $e8473c8c41411b48$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $e8473c8c41411b48$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $e8473c8c41411b48$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $673MF = parcelRequire("673MF");

var $bjGSs = parcelRequire("bjGSs");

var $VSDnB = parcelRequire("VSDnB");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $gyjU7 = parcelRequire("gyjU7");
function $e8473c8c41411b48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e8473c8c41411b48$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $e8473c8c41411b48$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $e8473c8c41411b48$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
const $e8473c8c41411b48$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $e8473c8c41411b48$export$cf9cf2a30a59265c = $e8473c8c41411b48$var$MultiValueGeneric;
const $e8473c8c41411b48$export$544aeea2a5ce08ee = $e8473c8c41411b48$var$MultiValueGeneric;
const $e8473c8c41411b48$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $e8473c8c41411b48$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $e8473c8c41411b48$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.025'
});
const $e8473c8c41411b48$var$renderIcon = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
        label: "",
        color: "currentColor"
    });
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        xcss: $e8473c8c41411b48$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
        label: "",
        color: "currentColor"
    }));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($673MF))), {
        label: "",
        primaryColor: "transparent",
        size: "small",
        secondaryColor: "inherit"
    });
};
function $e8473c8c41411b48$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $e8473c8c41411b48$var$disabledStyles : $e8473c8c41411b48$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, $e8473c8c41411b48$var$renderIcon())));
}
const $e8473c8c41411b48$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8473c8c41411b48$export$2e2bcd8739ae039 = $e8473c8c41411b48$var$MultiValue;

});


parcelRegister("8l2RA", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $6e6d67a90b457dc1$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $6e6d67a90b457dc1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3ttih = parcelRequire("3ttih");

var $2coFy = parcelRequire("2coFy");
const $6e6d67a90b457dc1$export$ef897119b7e920ba = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $3ttih.optionCSS)() : (0, $2coFy.optionCSS)(props);
const $6e6d67a90b457dc1$var$Option = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3ttih.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2coFy.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;

});
parcelRegister("3ttih", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $067c79fba4bdfbb2$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $067c79fba4bdfbb2$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $067c79fba4bdfbb2$export$ef897119b7e920ba = ()=>({});
const $067c79fba4bdfbb2$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pknj1ic",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pknj1ic",
    focusedSelected: "_bfhki1yw"
};
const $067c79fba4bdfbb2$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $067c79fba4bdfbb2$var$optionStyles.root,
            isFocused && $067c79fba4bdfbb2$var$optionStyles.focused,
            isSelected && $067c79fba4bdfbb2$var$optionStyles.selected,
            isFocused && isSelected && $067c79fba4bdfbb2$var$optionStyles.focusedSelected,
            isDisabled && $067c79fba4bdfbb2$var$optionStyles.disabled,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$067c79fba4bdfbb2$export$2e2bcd8739ae039 = $067c79fba4bdfbb2$var$Option;

});

parcelRegister("2coFy", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $026e08b240e6e5e0$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $026e08b240e6e5e0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $026e08b240e6e5e0$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $026e08b240e6e5e0$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$026e08b240e6e5e0$export$2e2bcd8739ae039 = $026e08b240e6e5e0$var$Option;

});


parcelRegister("kKm82", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $889d652a9d0dc097$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $889d652a9d0dc097$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dw3lH = parcelRequire("dw3lH");

var $iL8GQ = parcelRequire("iL8GQ");
const $889d652a9d0dc097$export$5f3ffacd6594d90f = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $dw3lH.placeholderCSS)() : (0, $iL8GQ.placeholderCSS)(props);
const $889d652a9d0dc097$var$Placeholder = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dw3lH.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iL8GQ.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;

});
parcelRegister("dw3lH", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $7011c54f7352f26b$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $7011c54f7352f26b$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $7011c54f7352f26b$export$5f3ffacd6594d90f = ()=>({});
const $7011c54f7352f26b$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $7011c54f7352f26b$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $7011c54f7352f26b$var$placeholderStyles.root,
            isDisabled && $7011c54f7352f26b$var$placeholderStyles.disabled,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7011c54f7352f26b$export$2e2bcd8739ae039 = $7011c54f7352f26b$var$Placeholder;

});

parcelRegister("iL8GQ", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $aeddb46ca1eecdf2$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $aeddb46ca1eecdf2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $aeddb46ca1eecdf2$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $aeddb46ca1eecdf2$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aeddb46ca1eecdf2$export$2e2bcd8739ae039 = $aeddb46ca1eecdf2$var$Placeholder;

});


parcelRegister("hpcbi", function(module, exports) {

$parcel$export(module.exports, "css", () => $aff94346c62a222f$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $aff94346c62a222f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $5Zgwp = parcelRequire("5Zgwp");

var $9pbjn = parcelRequire("9pbjn");
const $aff94346c62a222f$export$dbf350e5966cf602 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5Zgwp.css)() : (0, $9pbjn.css)(props);
const $aff94346c62a222f$var$SingleValue = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Zgwp.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9pbjn.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;

});
parcelRegister("5Zgwp", function(module, exports) {

$parcel$export(module.exports, "css", () => $11f234ca28812396$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $11f234ca28812396$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $11f234ca28812396$export$dbf350e5966cf602 = ()=>({});
const $11f234ca28812396$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _jqf6bf1n _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $11f234ca28812396$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $11f234ca28812396$var$styles.root,
            isDisabled && $11f234ca28812396$var$styles.disalbed,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11f234ca28812396$export$2e2bcd8739ae039 = $11f234ca28812396$var$SingleValue;

});

parcelRegister("9pbjn", function(module, exports) {

$parcel$export(module.exports, "css", () => $0f24309584527733$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $0f24309584527733$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $0f24309584527733$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $0f24309584527733$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0f24309584527733$export$2e2bcd8739ae039 = $0f24309584527733$var$SingleValue;

});



parcelRegister("b9dFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $768d8504b373d7ff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $5n5w4 = parcelRequire("5n5w4");
var $283js = parcelRequire("283js");
var $iGDLS = parcelRequire("iGDLS");

var $4wJSY = parcelRequire("4wJSY");

var $2Z7Iz = parcelRequire("2Z7Iz");

var $9KnKW = parcelRequire("9KnKW");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");


var $7K5PP = parcelRequire("7K5PP");

var $1DATb = parcelRequire("1DATb");

var $hT6ku = parcelRequire("hT6ku");

var $9DWu0 = parcelRequire("9DWu0");
/**
 * Are we rendering on the client or server?
 */ const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $768d8504b373d7ff$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $768d8504b373d7ff$var$defaultPopperProps = {
    modifiers: $768d8504b373d7ff$var$modifiers,
    placement: 'bottom-start'
};
const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$768d8504b373d7ff$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $hT6ku.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5n5w4.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iGDLS.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9DWu0.NotifyOpenLayerObserver), {
                    isOpen: (0, $VSDnB.fg)('platform_dst_layer_observer_select') && this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $hT6ku.defaultComponents),
            mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $hT6ku.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) // I might want to use a comma instead of a period here, when the feature flag is removed.
                    ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `${optionName}, (${optionIndex + 1} of ${totalLength})` : `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? '' : ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $1DATb.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $1DATb.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $1DATb.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    // Safari still does not announce the first option when menu is opened, so forcing a change to the input label
                    // will include the first option in the initial announcement.
                    if (!(0, $VSDnB.fg)('design_system_select-a11y-improvement') || (0, $2Z7Iz.isSafari)() && (0, $VSDnB.fg)('design_system_select-a11y-improvement')) updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $283js.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hT6ku.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                                    label: providedAriaLabel,
                                    // TODO: Popup Select does not work well with active-descendant
                                    "aria-live": (0, $2Z7Iz.isAppleDevice)() && (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? 'assertive' // only needed on Apple products
                                     : undefined,
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $7VXAu.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId,
                                    ariaLiveMessages: {
                                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                                        onFocus: onReactSelectFocus,
                                        ...props.ariaLiveMessages // priority to use user handlers if provided
                                    }
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $VSDnB.fg)('platform_dst_layer_observer_select')) return;
            this.close();
        };
    }
}

});
parcelRegister("5n5w4", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $3e93612641040812$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $3e93612641040812$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $3e93612641040812$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("283js", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $18cee5f949ac4034$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");

var $fNOWl = parcelRequire("fNOWl");
var $18cee5f949ac4034$var$NOOP = function NOOP() {
    return void 0;
};
var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $eclLw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fNOWl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
            update: update || $18cee5f949ac4034$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $eclLw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("eclLw", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $a56311d537d20f47$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $a56311d537d20f47$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $a56311d537d20f47$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $a56311d537d20f47$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $a56311d537d20f47$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("fNOWl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b812f23d0bbb9e85$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Pv9O = parcelRequire("8Pv9O");

var $lHrkK = parcelRequire("lHrkK");

var $eclLw = parcelRequire("eclLw");
var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $8Pv9O.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("8Pv9O", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $66db415bc009fd50$export$8f7491d57c8f97a9);

var $dsn8Y = parcelRequire("dsn8Y");

var $4TVC8 = parcelRequire("4TVC8");

var $j8nKB = parcelRequire("j8nKB");

var $baic6 = parcelRequire("baic6");

var $1AoLg = parcelRequire("1AoLg");

var $gy4Xr = parcelRequire("gy4Xr");

var $3dDWl = parcelRequire("3dDWl");

var $1DdSC = parcelRequire("1DdSC");

var $gzAfz = parcelRequire("gzAfz");

var $6iLAT = parcelRequire("6iLAT");


var $66db415bc009fd50$export$d34966752335dd47 = [
    (0, $4TVC8.default),
    (0, $j8nKB.default),
    (0, $baic6.default),
    (0, $1AoLg.default),
    (0, $gy4Xr.default),
    (0, $3dDWl.default),
    (0, $1DdSC.default),
    (0, $gzAfz.default),
    (0, $6iLAT.default)
];
var $66db415bc009fd50$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dsn8Y.popperGenerator)({
    defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("dsn8Y", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $9cbfd7bdb6a4f3f1$export$ed5e13716264f202);

var $gvlia = parcelRequire("gvlia");

var $jkGDj = parcelRequire("jkGDj");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $kcmIg = parcelRequire("kcmIg");

var $a8clb = parcelRequire("a8clb");

var $i9xH7 = parcelRequire("i9xH7");


var $gmkfg = parcelRequire("gmkfg");
var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9cbfd7bdb6a4f3f1$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gmkfg.isElement)(reference) ? (0, $2r6BH.default)(reference) : reference.contextElement ? (0, $2r6BH.default)(reference.contextElement) : [],
                    popper: (0, $2r6BH.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $kcmIg.default)((0, $i9xH7.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gvlia.default)(reference, (0, $gbHJy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $jkGDj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a8clb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gvlia", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0400ebb908e52cb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $9FFjG = parcelRequire("9FFjG");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");

var $imzt5 = parcelRequire("imzt5");

var $eVELE = parcelRequire("eVELE");

var $c6EdA = parcelRequire("c6EdA");

var $90xPK = parcelRequire("90xPK");
function $c0400ebb908e52cb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $90xPK.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $90xPK.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gmkfg.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gmkfg.isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
    var documentElement = (0, $eVELE.default)(offsetParent);
    var rect = (0, $g2O7Z.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f5IBt.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c6EdA.default)(documentElement)) scroll = (0, $9FFjG.default)(offsetParent);
        if ((0, $gmkfg.isHTMLElement)(offsetParent)) {
            offsets = (0, $g2O7Z.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $imzt5.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("g2O7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae3b796a534b2cf$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");

var $90xPK = parcelRequire("90xPK");

var $1Prpe = parcelRequire("1Prpe");

var $d8bsQ = parcelRequire("d8bsQ");
function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gmkfg.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $90xPK.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $90xPK.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gmkfg.isElement)(element) ? (0, $1Prpe.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d8bsQ.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gmkfg", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $be8e67adfa808002$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $be8e67adfa808002$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $be8e67adfa808002$export$af51f0f06c0f328a);

var $1Prpe = parcelRequire("1Prpe");
function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1Prpe.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1Prpe.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1Prpe.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("1Prpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $154fd01b154b825f$export$2e2bcd8739ae039);
function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("90xPK", function(module, exports) {

$parcel$export(module.exports, "max", () => $68ee5bce69e9df7e$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $68ee5bce69e9df7e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $68ee5bce69e9df7e$export$2077e0241d6afd3c);
var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d8bsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f4ea48bb7f7060$export$2e2bcd8739ae039);

var $j5Xhq = parcelRequire("j5Xhq");
function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j5Xhq.default)());
}

});
parcelRegister("j5Xhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6c77c242bcf4cf$export$2e2bcd8739ae039);
function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9FFjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a7fdf85bb2e8b8$export$2e2bcd8739ae039);

var $8YTLN = parcelRequire("8YTLN");

var $1Prpe = parcelRequire("1Prpe");

var $gmkfg = parcelRequire("gmkfg");

var $i1ad3 = parcelRequire("i1ad3");
function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
    if (node === (0, $1Prpe.default)(node) || !(0, $gmkfg.isHTMLElement)(node)) return (0, $8YTLN.default)(node);
    else return (0, $i1ad3.default)(node);
}

});
parcelRegister("8YTLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $689f300ec0defb42$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
    var win = (0, $1Prpe.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("i1ad3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e03d69dfb9832f$export$2e2bcd8739ae039);
function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("f5IBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc9ebf0aa1487e4$export$2e2bcd8739ae039);
function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("imzt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e5cb506db8cdcb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $eVELE = parcelRequire("eVELE");

var $8YTLN = parcelRequire("8YTLN");
function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $g2O7Z.default)((0, $eVELE.default)(element)).left + (0, $8YTLN.default)(element).scrollLeft;
}

});
parcelRegister("eVELE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade6032ba4b824fe$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gmkfg.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("c6EdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d053e13cecc73ee$export$2e2bcd8739ae039);

var $1ix2F = parcelRequire("1ix2F");
function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1ix2F.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("1ix2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f211a5db2cb1d1b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
    return (0, $1Prpe.default)(element).getComputedStyle(element);
}

});



parcelRegister("jkGDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e130f49f6e9ebcb4$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");
function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $g2O7Z.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2r6BH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c633a6ac170841a$export$2e2bcd8739ae039);

var $k82dT = parcelRequire("k82dT");

var $eTUzl = parcelRequire("eTUzl");

var $1Prpe = parcelRequire("1Prpe");

var $c6EdA = parcelRequire("c6EdA");
function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $k82dT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1Prpe.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c6EdA.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, $eTUzl.default)(target)));
}

});
parcelRegister("k82dT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7647704a508683$export$2e2bcd8739ae039);

var $eTUzl = parcelRequire("eTUzl");

var $c6EdA = parcelRequire("c6EdA");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
function $ea7647704a508683$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $f5IBt.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gmkfg.isHTMLElement)(node) && (0, $c6EdA.default)(node)) return node;
    return $ea7647704a508683$export$2e2bcd8739ae039((0, $eTUzl.default)(node));
}

});
parcelRegister("eTUzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad921528f26834dd$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $eVELE = parcelRequire("eVELE");

var $gmkfg = parcelRequire("gmkfg");
function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
    if ((0, $f5IBt.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gmkfg.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eVELE.default)(element) // fallback
    );
}

});



parcelRegister("gbHJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f9908a1e4106f$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $f5IBt = parcelRequire("f5IBt");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $6hs9X = parcelRequire("6hs9X");

var $eTUzl = parcelRequire("eTUzl");

var $j5Xhq = parcelRequire("j5Xhq");
function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
    if (!(0, $gmkfg.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1ix2F.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $bc8f9908a1e4106f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j5Xhq.default)());
    var isIE = /Trident/i.test((0, $j5Xhq.default)());
    if (isIE && (0, $gmkfg.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1ix2F.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $eTUzl.default)(element);
    if ((0, $gmkfg.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gmkfg.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $f5IBt.default)(currentNode)) < 0){
        var css = (0, $1ix2F.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
    var window = (0, $1Prpe.default)(element);
    var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6hs9X.default)(offsetParent) && (0, $1ix2F.default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f5IBt.default)(offsetParent) === 'html' || (0, $f5IBt.default)(offsetParent) === 'body' && (0, $1ix2F.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
}

});
parcelRegister("6hs9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $492a2c861940c94d$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");
function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $f5IBt.default)(element)) >= 0;
}

});


parcelRegister("kcmIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb468bf0752088cc$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");
function $eb468bf0752088cc$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $eb468bf0752088cc$var$order(modifiers); // order based on phase
    return (0, $kJPed.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("kJPed", function(module, exports) {

$parcel$export(module.exports, "top", () => $f18fbf7b212a7c8e$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f18fbf7b212a7c8e$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f18fbf7b212a7c8e$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f18fbf7b212a7c8e$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f18fbf7b212a7c8e$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f18fbf7b212a7c8e$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f18fbf7b212a7c8e$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f18fbf7b212a7c8e$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $f18fbf7b212a7c8e$export$d087d3878fdf71d5);
var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
    $f18fbf7b212a7c8e$export$1e95b668f3b82d,
    $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
    $f18fbf7b212a7c8e$export$79ffe56a765070d2,
    $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
];
var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []);
var $f18fbf7b212a7c8e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
    $f18fbf7b212a7c8e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
    $f18fbf7b212a7c8e$export$421679a7c3d56e,
    $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
    $f18fbf7b212a7c8e$export$6964f6c886723980,
    $f18fbf7b212a7c8e$export$c65e99957a05207c,
    $f18fbf7b212a7c8e$export$f22da7240b7add18,
    $f18fbf7b212a7c8e$export$bab79516f2d662fe,
    $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
    $f18fbf7b212a7c8e$export$68d8715fc104d294,
    $f18fbf7b212a7c8e$export$70a6e5159acce2e6
];

});


parcelRegister("a8clb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7604395822cc5d61$export$2e2bcd8739ae039);
function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("i9xH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3733441fcf2e882$export$2e2bcd8739ae039);
function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("4TVC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3918fd6b815bcf57$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
var $3918fd6b815bcf57$var$passive = {
    passive: true
};
function $3918fd6b815bcf57$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1Prpe.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3918fd6b815bcf57$var$effect,
    data: {}
};

});

parcelRegister("j8nKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee1300a39219bb5$export$2e2bcd8739ae039);

var $dJ0Jl = parcelRequire("dJ0Jl");
function $dee1300a39219bb5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dJ0Jl.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dee1300a39219bb5$var$popperOffsets,
    data: {}
};

});
parcelRegister("dJ0Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe00b5c334118ac$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $9GF9F = parcelRequire("9GF9F");

var $kJPed = parcelRequire("kJPed");
function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $QXpw1.default)(placement) : null;
    var variation = placement ? (0, $cGRJ4.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $kJPed.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $kJPed.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $kJPed.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $kJPed.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9GF9F.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $kJPed.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $kJPed.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("QXpw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f2f123ac4a9fdf$export$2e2bcd8739ae039);

function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("cGRJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d315208040ceed$export$2e2bcd8739ae039);
function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9GF9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d7f5cda4210aa3$export$2e2bcd8739ae039);
function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("baic6", function(module, exports) {

$parcel$export(module.exports, "default", () => $820ebddbe0682e4f$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $gbHJy = parcelRequire("gbHJy");

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $90xPK = parcelRequire("90xPK");
var $820ebddbe0682e4f$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $90xPK.round)(x * dpr) / dpr || 0,
        y: (0, $90xPK.round)(y * dpr) / dpr || 0
    };
}
function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $kJPed.left);
    var sideY = (0, $kJPed.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $gbHJy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1Prpe.default)(popper)) {
            offsetParent = (0, $eVELE.default)(popper);
            if ((0, $1ix2F.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $kJPed.top) || (placement === (0, $kJPed.left) || placement === (0, $kJPed.right)) && variation === (0, $kJPed.end)) {
            sideY = (0, $kJPed.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $kJPed.left) || (placement === (0, $kJPed.top) || placement === (0, $kJPed.bottom)) && variation === (0, $kJPed.end)) {
            sideX = (0, $kJPed.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $820ebddbe0682e4f$var$unsetSides);
    var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1Prpe.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $820ebddbe0682e4f$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $QXpw1.default)(state.placement),
        variation: (0, $cGRJ4.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $820ebddbe0682e4f$var$computeStyles,
    data: {}
};

});

parcelRegister("1AoLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $127c5c56b9511f5f$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
// and applies them to the HTMLElements such as popper and arrow
function $127c5c56b9511f5f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $127c5c56b9511f5f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $127c5c56b9511f5f$var$applyStyles,
    effect: $127c5c56b9511f5f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("gy4Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c3aad300d72ee1$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $kJPed = parcelRequire("kJPed");
function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $QXpw1.default)(placement);
    var invertDistance = [
        (0, $kJPed.left),
        (0, $kJPed.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c0c3aad300d72ee1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $kJPed.placements).reduce(function(acc, placement) {
        acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $c0c3aad300d72ee1$var$offset
};

});

parcelRegister("3dDWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $258191447a7022df$export$2e2bcd8739ae039);

var $jwSgb = parcelRequire("jwSgb");

var $QXpw1 = parcelRequire("QXpw1");

var $4tIVJ = parcelRequire("4tIVJ");

var $kgkit = parcelRequire("kgkit");

var $cqF2x = parcelRequire("cqF2x");

var $kJPed = parcelRequire("kJPed");

var $cGRJ4 = parcelRequire("cGRJ4");
function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
    if ((0, $QXpw1.default)(placement) === (0, $kJPed.auto)) return [];
    var oppositePlacement = (0, $jwSgb.default)(placement);
    return [
        (0, $4tIVJ.default)(placement),
        oppositePlacement,
        (0, $4tIVJ.default)(oppositePlacement)
    ];
}
function $258191447a7022df$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $QXpw1.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jwSgb.default)(preferredPlacement)
    ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $QXpw1.default)(placement) === (0, $kJPed.auto) ? (0, $cqF2x.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $QXpw1.default)(placement);
        var isStartVariation = (0, $cGRJ4.default)(placement) === (0, $kJPed.start);
        var isVertical = [
            (0, $kJPed.top),
            (0, $kJPed.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $kJPed.right) : (0, $kJPed.left) : isStartVariation ? (0, $kJPed.bottom) : (0, $kJPed.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var altVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $258191447a7022df$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $258191447a7022df$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jwSgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37b1862c86f39c4$export$2e2bcd8739ae039);
var $e37b1862c86f39c4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e37b1862c86f39c4$var$hash[matched];
    });
}

});

parcelRegister("4tIVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $342cb90cb2622617$export$2e2bcd8739ae039);
var $342cb90cb2622617$var$hash = {
    start: 'end',
    end: 'start'
};
function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $342cb90cb2622617$var$hash[matched];
    });
}

});

parcelRegister("kgkit", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec050bcf5e349283$export$2e2bcd8739ae039);

var $dknpr = parcelRequire("dknpr");

var $eVELE = parcelRequire("eVELE");

var $g2O7Z = parcelRequire("g2O7Z");

var $dJ0Jl = parcelRequire("dJ0Jl");

var $h8W1z = parcelRequire("h8W1z");

var $kJPed = parcelRequire("kJPed");

var $gmkfg = parcelRequire("gmkfg");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");
function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $kJPed.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $kJPed.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $kJPed.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
    var altContext = elementContext === (0, $kJPed.popper) ? (0, $kJPed.reference) : (0, $kJPed.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dknpr.default)((0, $gmkfg.isElement)(element) ? element : element.contextElement || (0, $eVELE.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $g2O7Z.default)(state.elements.reference);
    var popperOffsets = (0, $dJ0Jl.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $h8W1z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $kJPed.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $kJPed.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $kJPed.right),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $kJPed.top),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dknpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3f4d3932acb3b2$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $3V2hG = parcelRequire("3V2hG");

var $9NXD7 = parcelRequire("9NXD7");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $g2O7Z = parcelRequire("g2O7Z");

var $eTUzl = parcelRequire("eTUzl");

var $j6yPg = parcelRequire("j6yPg");

var $f5IBt = parcelRequire("f5IBt");

var $h8W1z = parcelRequire("h8W1z");

var $90xPK = parcelRequire("90xPK");
function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $g2O7Z.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $kJPed.viewport) ? (0, $h8W1z.default)((0, $3V2hG.default)(element, strategy)) : (0, $gmkfg.isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $h8W1z.default)((0, $9NXD7.default)((0, $eVELE.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9b3f4d3932acb3b2$var$getClippingParents(element) {
    var clippingParents = (0, $2r6BH.default)((0, $eTUzl.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1ix2F.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gmkfg.isHTMLElement)(element) ? (0, $gbHJy.default)(element) : element;
    if (!(0, $gmkfg.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gmkfg.isElement)(clippingParent) && (0, $j6yPg.default)(clippingParent, clipperElement) && (0, $f5IBt.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $90xPK.max)(rect.top, accRect.top);
        accRect.right = (0, $90xPK.min)(rect.right, accRect.right);
        accRect.bottom = (0, $90xPK.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $90xPK.max)(rect.left, accRect.left);
        return accRect;
    }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3V2hG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da877912142c34b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $imzt5 = parcelRequire("imzt5");

var $d8bsQ = parcelRequire("d8bsQ");
function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1Prpe.default)(element);
    var html = (0, $eVELE.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d8bsQ.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $imzt5.default)(element),
        y: y
    };
}

});

parcelRegister("9NXD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7236f1f1532b7fe8$export$2e2bcd8739ae039);

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $imzt5 = parcelRequire("imzt5");

var $8YTLN = parcelRequire("8YTLN");

var $90xPK = parcelRequire("90xPK");
function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eVELE.default)(element);
    var winScroll = (0, $8YTLN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $90xPK.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $90xPK.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $imzt5.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1ix2F.default)(body || html).direction === 'rtl') x += (0, $90xPK.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("j6yPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de89978be23479c4$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gmkfg.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("h8W1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b0316bb2f8fd97$export$2e2bcd8739ae039);
function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gIXWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cf410c4fe133f4$export$2e2bcd8739ae039);

var $1ANH0 = parcelRequire("1ANH0");
function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ANH0.default)(), paddingObject);
}

});
parcelRegister("1ANH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $128fb32b18b92ffa$export$2e2bcd8739ae039);
function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("50KfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cqF2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c7bf65fbdbec33$export$2e2bcd8739ae039);

var $cGRJ4 = parcelRequire("cGRJ4");

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");

var $QXpw1 = parcelRequire("QXpw1");
function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $kJPed.placements) : _options$allowedAutoP;
    var variation = (0, $cGRJ4.default)(placement);
    var placements = variation ? flipVariations ? (0, $kJPed.variationPlacements) : (0, $kJPed.variationPlacements).filter(function(placement) {
        return (0, $cGRJ4.default)(placement) === variation;
    }) : (0, $kJPed.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $QXpw1.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("1DdSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $13043339457d5bc5$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $QXpw1 = parcelRequire("QXpw1");

var $9GF9F = parcelRequire("9GF9F");

var $dNtrn = parcelRequire("dNtrn");

var $4WpIh = parcelRequire("4WpIh");

var $jkGDj = parcelRequire("jkGDj");

var $gbHJy = parcelRequire("gbHJy");

var $kgkit = parcelRequire("kgkit");

var $cGRJ4 = parcelRequire("cGRJ4");

var $1ANH0 = parcelRequire("1ANH0");

var $90xPK = parcelRequire("90xPK");
function $13043339457d5bc5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $kgkit.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var variation = (0, $cGRJ4.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9GF9F.default)(basePlacement);
    var altAxis = (0, $dNtrn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
        var altSide = mainAxis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $kJPed.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $kJPed.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $jkGDj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ANH0.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4WpIh.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $gbHJy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4WpIh.within)(tether ? (0, $90xPK.min)(min, tetherMin) : min, offset, tether ? (0, $90xPK.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $kJPed.top) : (0, $kJPed.left);
        var _altSide = mainAxis === 'x' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $kJPed.top),
            (0, $kJPed.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4WpIh.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $4WpIh.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $13043339457d5bc5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $13043339457d5bc5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dNtrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("4WpIh", function(module, exports) {

$parcel$export(module.exports, "within", () => $3990864f59117d05$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $3990864f59117d05$export$86c8af6d3ef0b4a);

var $90xPK = parcelRequire("90xPK");
function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
    return (0, $90xPK.max)(min, (0, $90xPK.min)(value, max));
}
function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("gzAfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10c08bd5e0ed9fb$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $jkGDj = parcelRequire("jkGDj");

var $j6yPg = parcelRequire("j6yPg");

var $gbHJy = parcelRequire("gbHJy");

var $9GF9F = parcelRequire("9GF9F");

var $4WpIh = parcelRequire("4WpIh");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");

var $kJPed = parcelRequire("kJPed");
var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
};
function $c10c08bd5e0ed9fb$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var axis = (0, $9GF9F.default)(basePlacement);
    var isVertical = [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $jkGDj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
    var maxProp = axis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $gbHJy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4WpIh.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c10c08bd5e0ed9fb$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $j6yPg.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c10c08bd5e0ed9fb$var$arrow,
    effect: $c10c08bd5e0ed9fb$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("6iLAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $496957b0c691a0ed$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");
function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $kJPed.top),
        (0, $kJPed.right),
        (0, $kJPed.bottom),
        (0, $kJPed.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $496957b0c691a0ed$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $kgkit.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $kgkit.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $496957b0c691a0ed$var$hide
};

});




parcelRegister("iGDLS", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $d9aafffd117cbcc1$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");
function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $eclLw.setRef)(innerRef, node);
        (0, $eclLw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $eclLw.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $eclLw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("2Z7Iz", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $f979f269481b61c7$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $f979f269481b61c7$export$e1865c3bedcd822b);
function $f979f269481b61c7$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $f979f269481b61c7$var$isIPhone() {
    return $f979f269481b61c7$var$testPlatform(/^iPhone/i);
}
function $f979f269481b61c7$var$isMac() {
    return $f979f269481b61c7$var$testPlatform(/^Mac/i);
}
function $f979f269481b61c7$var$isIPad() {
    return $f979f269481b61c7$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $f979f269481b61c7$var$isMac() && navigator.maxTouchPoints > 1;
}
function $f979f269481b61c7$var$isIOS() {
    return $f979f269481b61c7$var$isIPhone() || $f979f269481b61c7$var$isIPad();
}
function $f979f269481b61c7$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $f979f269481b61c7$export$e1865c3bedcd822b() {
    return $f979f269481b61c7$var$isMac() || $f979f269481b61c7$var$isIOS();
}

});

parcelRegister("7VXAu", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $11d0fd648d1f51c0$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $11d0fd648d1f51c0$export$e618dc39ac9ad607);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
    clearIndicator: (0, $95iuW.clearIndicatorCSS),
    container: (0, $h1QWG.containerCSS),
    control: (0, $eZFhY.css),
    dropdownIndicator: (0, $95iuW.dropdownIndicatorCSS),
    group: (0, $i48X9.groupCSS),
    groupHeading: (0, $i48X9.groupHeadingCSS),
    indicatorsContainer: (0, $h1QWG.indicatorsContainerCSS),
    input: (0, $dS5G5.inputCSS),
    loadingIndicator: (0, $95iuW.loadingIndicatorCSS),
    loadingMessage: (0, $aA8TC.loadingMessageCSS),
    menu: (0, $aA8TC.menuCSS),
    menuList: (0, $aA8TC.menuListCSS),
    menuPortal: (0, $aA8TC.menuPortalCSS),
    multiValue: (0, $hqcPo.multiValueCSS),
    multiValueLabel: (0, $hqcPo.multiValueLabelCSS),
    multiValueRemove: (0, $hqcPo.multiValueRemoveCSS),
    noOptionsMessage: (0, $aA8TC.noOptionsMessageCSS),
    option: (0, $8l2RA.optionCSS),
    placeholder: (0, $kKm82.placeholderCSS),
    singleValue: (0, $hpcbi.css),
    valueContainer: (0, $h1QWG.valueContainerCSS)
};
function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("7K5PP", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $c2d344e1481a2d3b$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, $3c98u.default)((0, $eAthk.default));
const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
const $c2d344e1481a2d3b$var$Select = (0, $994MI.default)({
    componentName: 'select',
    packageName: $c2d344e1481a2d3b$var$packageName,
    packageVersion: $c2d344e1481a2d3b$var$packageVersion
})((0, $cb25w.default)({
    onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $c2d344e1481a2d3b$var$packageName,
            packageVersion: $c2d344e1481a2d3b$var$packageVersion
        }
    })
})($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;

});
parcelRegister("eAthk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0cf20527a3a891$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("iaInK")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $9uJ4X = parcelRequire("9uJ4X");
const $6d0cf20527a3a891$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $iaInK.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $9uJ4X.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;

});
parcelRegister("2QhWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e863683b34816f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2Z7Iz = parcelRequire("2Z7Iz");

var $VSDnB = parcelRequire("VSDnB");

var $eEtcC = parcelRequire("eEtcC");

var $bChGW = parcelRequire("bChGW");

var $jtVgE = parcelRequire("jtVgE");
var $9cRAr = parcelRequire("9cRAr");
var $galqx = parcelRequire("galqx");

var $7uagk = parcelRequire("7uagk");

var $81i5b = parcelRequire("81i5b");

var $aA8TC = parcelRequire("aA8TC");

var $5JAlL = parcelRequire("5JAlL");

var $7VXAu = parcelRequire("7VXAu");

var $gyjU7 = parcelRequire("gyjU7");
const $d8e863683b34816f$export$9c21a3269931e1e6 = {
    // aria-live is by default with the live region so we don't need it
    // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
    'aria-live': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gyjU7.isTouchCapable)(),
    captureMenuScroll: !(0, $gyjU7.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5JAlL.createFilter)(),
    formatGroupLabel: (0, $eEtcC.formatGroupLabel),
    getOptionLabel: (0, $eEtcC.getOptionLabel),
    getOptionValue: (0, $eEtcC.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $eEtcC.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gyjU7.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
    const label = $d8e863683b34816f$var$getOptionLabel(props, option);
    const value = $d8e863683b34816f$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gyjU7.notNullish));
}
function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
    return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
}
function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
    return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
}
function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $d8e863683b34816f$var$instanceId = 1;
class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isVoiceOver = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && (0, $2Z7Iz.isAppleDevice)(), // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $gyjU7.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $gyjU7.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $gyjU7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $gyjU7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $gyjU7.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $gyjU7.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $d8e863683b34816f$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $d8e863683b34816f$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $7VXAu.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $bChGW.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $gyjU7.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $VSDnB.fg)('platform_dst_layer_observer_select')) return;
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
        this.state.selectValue = (0, $gyjU7.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $gyjU7.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $gyjU7.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription(action) {
        const descriptionProp = this.props['aria-describedby'] || this.props['descriptionId'];
        const { isMulti: isMulti } = this.props;
        const { selectValue: selectValue } = this.state;
        const defaultDescription = selectValue.length ? this.getElementId('live-region') : this.getElementId('placeholder');
        if (!isMulti && selectValue.length && action !== 'initial-input-focus') return;
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            return {
                'aria-describedby': descriptionProp ? [
                    descriptionProp,
                    defaultDescription,
                    multiMessage
                ].join(' ') : [
                    defaultDescription,
                    multiMessage
                ].join(' ')
            };
        } else return {
            'aria-describedby': descriptionProp ? [
                descriptionProp,
                defaultDescription
            ].join(' ') : defaultDescription
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-describedby': this.props['aria-describedby'] || descriptionId,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription(ariaSelection?.action)
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtVgE.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $gyjU7.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled && (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : isDisabled,
                'aria-describedby': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? headingId : undefined,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const calculateListboxLabel = ()=>{
            // First in name calculation, overwrites aria-label
            if (labelId) return {
                'aria-labelledby': labelId
            };
            // Second in name calcuation, overwrites everything else except aria-labelledby
            if (label) return {
                'aria-label': label
            };
            // Fallback if no label or labelId is provided, might catch label via <label for> otherwise
            // will most likely not have an accessible name
            return {
                'aria-labelledby': this.inputRef?.id || this.getElementId('input')
            };
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aA8TC.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galqx.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    'aria-multiselectable': (this.isVoiceOver || !commonProps.isMulti) && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox when ff is on
                                    ...(0, $VSDnB.fg)('design_system_select-a11y-improvement') && calculateListboxLabel()
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9cRAr.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $81i5b.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isVoiceOver
        });
    }
    renderMultiselectMessage() {
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: ", multiple selections available,"
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $2Z7Iz.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7uagk.NotifyOpenLayerObserver), {
                    isOpen: (0, $VSDnB.fg)('platform_dst_layer_observer_select') && this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("eEtcC", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $1a3d0f2eb875e1af$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $1a3d0f2eb875e1af$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $1a3d0f2eb875e1af$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $1a3d0f2eb875e1af$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("jtVgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe53037961824c2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $c8F86 = parcelRequire("c8F86");

var $39bHe = parcelRequire("39bHe");
function $afe53037961824c2$export$2e2bcd8739ae039(props) {
    return (0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8F86.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39bHe.default), {
        ...props
    });
}

});
parcelRegister("c8F86", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb54a2dcae79e275$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gyjU7 = parcelRequire("gyjU7");
const $fb54a2dcae79e275$var$dummyInputStyles = null;
function $fb54a2dcae79e275$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz"
        ])
    });
}

});

parcelRegister("39bHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ee388602b33ee1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $00ee388602b33ee1$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $00ee388602b33ee1$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $00ee388602b33ee1$var$dummyInputStyles
    });
}

});


parcelRegister("9cRAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a388fa48a9e96271$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $hU6tE = parcelRequire("hU6tE");

var $9Oi37 = parcelRequire("9Oi37");
const $a388fa48a9e96271$var$RequiredInput = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hU6tE.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Oi37.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;

});
parcelRegister("hU6tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $945267b00a632302$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");
const $945267b00a632302$var$styles = null;
const $945267b00a632302$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default),
        className: (0, $bwpsq.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw"
        ])
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$945267b00a632302$export$2e2bcd8739ae039 = $945267b00a632302$var$RequiredInput;

});

parcelRegister("9Oi37", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26802938ecd7698$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $eGmKJ = parcelRequire("eGmKJ");
function $c26802938ecd7698$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c26802938ecd7698$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $c26802938ecd7698$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $c26802938ecd7698$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c26802938ecd7698$export$2e2bcd8739ae039 = $c26802938ecd7698$var$RequiredInput;

});


parcelRegister("galqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15a49c0b3452f71$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $59IMp = parcelRequire("59IMp");

var $3jzRI = parcelRequire("3jzRI");
const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $59IMp.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $3jzRI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onClick: $e15a49c0b3452f71$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("59IMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c08116303d9e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
const $96c08116303d9e3a$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $gyjU7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("3jzRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $840302f0f43020c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $840302f0f43020c5$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $840302f0f43020c5$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $840302f0f43020c5$var$preventTouchMove(e) {
    e.preventDefault();
}
function $840302f0f43020c5$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $840302f0f43020c5$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $840302f0f43020c5$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $840302f0f43020c5$var$activeScrollLocks = 0;
const $840302f0f43020c5$var$listenerOptions = {
    capture: false,
    passive: false
};
function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $840302f0f43020c5$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("7uagk", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $7a4261c0e93bff6e$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $7a4261c0e93bff6e$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("81i5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ccfcdca5695e58$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7ZLLh = parcelRequire("7ZLLh");

var $bbz9Z = parcelRequire("bbz9Z");
const $a3ccfcdca5695e58$var$LiveRegion = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZLLh.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bbz9Z.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;

});
parcelRegister("7ZLLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $419a6948853c8feb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dQlbw = parcelRequire("dQlbw");

var $7lhj2 = parcelRequire("7lhj2");
const $419a6948853c8feb$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            }),
            !(0, $VSDnB.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        id: "aria-focused",
                        children: ariaFocused
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        id: "aria-guidance",
                        children: ariaGuidance
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                "aria-live": ariaLive,
                "aria-atomic": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
                "aria-relevant": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
                role: (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? 'status' : 'log',
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$419a6948853c8feb$export$2e2bcd8739ae039 = $419a6948853c8feb$var$LiveRegion;

});
parcelRegister("dQlbw", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $d3258ad64818881e$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $VSDnB = parcelRequire("VSDnB");
const $d3258ad64818881e$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || !(0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `option ${label}, deselected` : ''; // TODO: this should be handled on backspace|delete if no value, but doing it here first
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return label.length && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || !(0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.` : '';
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        // No longer needed after fg('design_system_select-a11y-improvement') is cleaned up
        if (context === 'menu' && !(0, $VSDnB.fg)('design_system_select-a11y-improvement')) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ' not selected'}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("7lhj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ce650310f44beb$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $59ce650310f44beb$var$styles = null;
const $59ce650310f44beb$var$A11yText = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _jqf6ydhy _uiztglyw _o5721q9c"
        ])
    });
var $59ce650310f44beb$export$2e2bcd8739ae039 = $59ce650310f44beb$var$A11yText;

});


parcelRegister("bbz9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $412616b9b75aa026$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $dQlbw = parcelRequire("dQlbw");

var $4Z3qi = parcelRequire("4Z3qi");
const $412616b9b75aa026$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $VSDnB.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance)));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4Z3qi.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4Z3qi.default), {
        "aria-live": ariaLive,
        "aria-atomic": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
        "aria-relevant": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
        role: (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$412616b9b75aa026$export$2e2bcd8739ae039 = $412616b9b75aa026$var$LiveRegion;

});
parcelRegister("4Z3qi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acf6ce83a1ce1d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");
function $1acf6ce83a1ce1d0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $1acf6ce83a1ce1d0$var$styles = {
    name: "jvmzbk-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;user-select:none;white-space:nowrap"
};
const $1acf6ce83a1ce1d0$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1acf6ce83a1ce1d0$var$styles,
        ...props
    });
var $1acf6ce83a1ce1d0$export$2e2bcd8739ae039 = $1acf6ce83a1ce1d0$var$A11yText;

});



parcelRegister("5JAlL", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $bXu2O = parcelRequire("bXu2O");
const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $bXu2O.stripDiacritics));
const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $bXu2O.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("bXu2O", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $df93339199dda18e$export$b5bee4b27048330b);
const $df93339199dda18e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $df93339199dda18e$var$diacriticToBase = {};
for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
    let diacritic = $df93339199dda18e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
    return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
};

});



parcelRegister("iaInK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e85c90096c52fe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $gyjU7.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("9uJ4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b6d9d338d10de1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("3c98u", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a0199069e875a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $1DATb = parcelRequire("1DATb");
function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'assertive',
            ariaLiveMessages: //TO DO: Still need live region for PopupSelect because of the menu being open by default
            (0, $1DATb.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $1DATb.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("1DATb", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $a998ee34d66f3da7$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $a998ee34d66f3da7$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $a998ee34d66f3da7$export$8ee33f304118fce4);

var $VSDnB = parcelRequire("VSDnB");
function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    if (focused.label && groupData?.label && (0, $VSDnB.fg)('design_system_select-a11y-improvement')) return `${focused.label}, ${groupData?.label}`;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("hT6ku", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $3f79b132df1e01ff$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $3f79b132df1e01ff$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $3f79b132df1e01ff$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gMMNe = parcelRequire("gMMNe");

var $bChGW = parcelRequire("bChGW");

var $jldZL = parcelRequire("jldZL");
const $3f79b132df1e01ff$var$menuDialogStyles = null;
const $3f79b132df1e01ff$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $3f79b132df1e01ff$var$dropdownStyles = null;
const $3f79b132df1e01ff$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMMNe))), {
            color: "currentColor",
            label: ""
        })
    });
const $3f79b132df1e01ff$var$controlStyles = null;
const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $3f79b132df1e01ff$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
        ...props
    });
const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).MultiValueRemove, {
        ...props
    });
const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
    Control: $3f79b132df1e01ff$var$Control,
    DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
    Menu: $3f79b132df1e01ff$var$Menu,
    ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
    MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
};

});
parcelRegister("gMMNe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));

var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c386fa4cb21167b0$var$SearchIcon = (props)=>/*#__PURE__*/ $c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
    }, props));
$c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;

});
parcelRegister("77ZoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $5308cfd5e45a5605$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $5308cfd5e45a5605$var$_search.default
    }));
$5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;

});



parcelRegister("9DWu0", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $072287da151cf77b$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $072287da151cf77b$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});


parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $k5uoT = parcelRequire("k5uoT");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $k5uoT.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $k5uoT.layers).navigation(),
    card: (0, $k5uoT.layers).card(),
    dialog: (0, $k5uoT.layers).dialog(),
    navigation: (0, $k5uoT.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $k5uoT.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $k5uoT.layers).navigation() - 1,
    layer: (0, $k5uoT.layers).layer(),
    blanket: (0, $k5uoT.layers).blanket(),
    modal: (0, $k5uoT.layers).modal(),
    flag: (0, $k5uoT.layers).flag(),
    spotlight: (0, $k5uoT.layers).spotlight(),
    tooltip: (0, $k5uoT.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});

const $58a8cc6dba6ea954$export$8bd078c872bc40fb = 500;

parcelRegister("4HmJy", function(module, exports) {

$parcel$export(module.exports, "controlHeight", () => $e0e3bda040aef7bc$export$9b3bae4d96b17b58);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $e0e3bda040aef7bc$export$9b3bae4d96b17b58 = 58;

});

parcelRegister("dAYGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad341b23adec6d1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $k2Dsk = parcelRequire("k2Dsk");
class $2ad341b23adec6d1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isSearchEnabled: false
        };
    }
    renderFieldSearch() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2ad341b23adec6d1$var$ControlWrapper, {
            ...this.props.innerProps,
            onClick: this.onClick,
            ref: this.props.innerRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "navigation-apps.common.compontents.switcher.switcher.control"
        }, this.props.children);
    }
    renderEmptySearch() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2ad341b23adec6d1$var$EmptyControlWrapper, null, this.renderFieldSearch());
    }
    render() {
        if (!this.props.isSearchEnabled) return this.renderEmptySearch();
        return this.renderFieldSearch();
    }
    constructor(...args){
        super(...args), this.onClick = (0, $k2Dsk.stopImmediatePropagation)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ad341b23adec6d1$var$ControlWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zludwz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $2ad341b23adec6d1$var$EmptyControlWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4t3iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k2Dsk", function(module, exports) {

$parcel$export(module.exports, "stopImmediatePropagation", () => $df6728ffcf902167$export$d5cb5f1c8a62fdf1);
const $df6728ffcf902167$export$d5cb5f1c8a62fdf1 = (eventHandler)=>// menu should no close when user click on any button
    // and classic stopPropagation does not work because
    // "close popup" event is attached to document
    // Ref: https://github.com/facebook/react/blob/a1be17140d/packages/react-dom/src/events/ReactBrowserEventEmitter.js
    (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        return eventHandler(e);
    };

});


parcelRegister("bTOZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $086eebfe452501b2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $99M5v = parcelRequire("99M5v");

var $60SKR = parcelRequire("60SKR");
const $086eebfe452501b2$var$styles = {
    root: "_1tnq1se7 _ulx8glyw _1yubudwz _18y111bn _1dy7udwz _16hgr01l _btpd1ex1 _1kba1h6o _1w901fxt _18y11j9a _u1mb1j9a _ksby1fxt"
};
class $086eebfe452501b2$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static renderIcon() {
        // @ts-expect-error - TS2769 - No overload matches this call.
        return /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            LEGACY_size: "small"
        });
    }
    render() {
        const { label: label, onClick: onClick } = this.props;
        return /*#__PURE__*/ $5uXOq.createElement((0, $60SKR.Item), {
            // @ts-expect-error - TS2322 - Type '{ onClick: () => void; text: string; before: () => Element; styles: (state: any) => { '&:focus': { backgroundColor: string; border: string; borderTop: string; }; '& [data-item-elem-before]': { marginRight: string; color: string; }; ... 5 more ...; alignItems: string; }; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
            onClick: onClick,
            text: label,
            before: $086eebfe452501b2$export$2e2bcd8739ae039.renderIcon,
            className: (0, $bwpsq.default)([
                $086eebfe452501b2$var$styles.root
            ])
        });
    }
}

});
parcelRegister("99M5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa418e9a366cd8$var$AddIcon = (props)=>/*#__PURE__*/ $6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
    }, props));
$6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;

});
parcelRegister("7ymNM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
function $57fd655943aa23fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57fd655943aa23fe$var$AddIcon = (props)=>/*#__PURE__*/ $57fd655943aa23fe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $57fd655943aa23fe$var$_add.default
    }));
$57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;

});


parcelRegister("60SKR", function(module, exports) {

$parcel$export(module.exports, "Item", () => $1bdad1b694e9f595$export$6d08773d2e66f8f2);

var $5uXOq = parcelRequire("5uXOq");

var $1aogK = parcelRequire("1aogK");

var $hjSul = parcelRequire("hjSul");
const $1bdad1b694e9f595$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, href: href, target: target, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        ref: ref
    };
    return href != null ? // @ts-expect-error - TS2322 - Type '{ href: string; target: (HTMLAttributeAnchorTarget & ("_self" | "_blank" | "_parent" | "_top")) | undefined; children: ReactNode; ref: ((instance: LinkProps | null) => void) | MutableRefObject<...> | null; ... 266 more ...; prefetch?: false | ... 2 more ... | undefined; }' is not assignable to type 'RefAttributes<HTMLAnchorElement | HTMLButtonElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        target: target
    }) : // @ts-expect-error - TS2322 - Type '{ children: ReactNode; ref: ((instance: LinkProps | null) => void) | MutableRefObject<LinkProps | null> | null; download?: any; ... 265 more ...; prefetch?: false | ... 2 more ... | undefined; }' is not assignable to type 'DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", commonProps, children);
});
const $1bdad1b694e9f595$export$6d08773d2e66f8f2 = ({ CustomItem: CustomItem = (0, $1aogK.default), component: // @ts-expect-error - component props do not match
component = $1bdad1b694e9f595$var$WrapperComponent, text: text = null, before: before = ()=>null, after: after = ()=>null, subText: subText, className: className, ...rest })=>{
    const IconBefore = before;
    const IconAfter = after;
    const customProps = {
        ...rest,
        className: className,
        component: component,
        description: subText,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconBefore, {
            color: "currentColor"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconAfter, {
            color: "currentColor"
        }),
        children: text
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomItem, customProps);
};

});


parcelRegister("48kqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c6e15b553185ea0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $bChGW = parcelRequire("bChGW");

var $eZJjh = parcelRequire("eZJjh");

var $k2Dsk = parcelRequire("k2Dsk");
class $6c6e15b553185ea0$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onShowMore: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    renderShowMore() {
        const { showMore: showMore } = this.props.data;
        if (!showMore) return null;
        if (showMore.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c6e15b553185ea0$var$ShowMoreWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "medium"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c6e15b553185ea0$var$ShowMoreWrapper, {
            onKeyDown: this.onShowMoreKeyDown,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-test-id": "navigation-apps.common.compontents.switcher.switcher.group.show-more"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            role: "option",
            onClick: this.onShowMoreClick
        }, showMore.label));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, this.props), this.renderShowMore());
    }
    constructor(...args){
        super(...args), this.onShowMoreKeyDown = (e)=>{
            // menu should be able to close
            // but all other events should not be passed to the react-select
            if (e.key !== 'Escape') e.stopPropagation();
        }, this.onShowMoreClick = (0, $k2Dsk.stopImmediatePropagation)(()=>this.props.onShowMore());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c6e15b553185ea0$var$ShowMoreWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6rDs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37adfa019026a8a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2xSAL = parcelRequire("2xSAL");
const $b37adfa019026a8a$var$Input = ({ placeholder: placeholder, onChange: onChange, value: value, inputProps: selectInputProps })=>{
    const inputProps = {
        'aria-activedescendant': selectInputProps['aria-activedescendant'],
        'aria-autocomplete': selectInputProps['aria-autocomplete'],
        'aria-controls': selectInputProps['aria-controls'],
        'aria-errormessage': selectInputProps['aria-errormessage'],
        'aria-expanded': selectInputProps['aria-expanded'],
        'aria-haspopup': selectInputProps['aria-haspopup'],
        'aria-invalid': selectInputProps['aria-invalid'],
        role: selectInputProps.role
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        isAlwaysExpanded: true,
        placeholder: placeholder,
        autoFocus: true,
        shouldFitContainerWidth: true,
        onChange: onChange,
        value: value,
        id: selectInputProps.id,
        describedById: selectInputProps['aria-describedby'],
        ariaLabelText: selectInputProps['aria-label'],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onFocus: selectInputProps.onFocus,
        inputProps: inputProps
    });
};
var $b37adfa019026a8a$export$2e2bcd8739ae039 = $b37adfa019026a8a$var$Input;

});
parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $2NMNM = parcelRequire("2NMNM");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? {
            reducedHeight: reducedHeight
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fW62l", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("kY99m", function(module, exports) {

$parcel$export(module.exports, "default", () => $509076ff0c6afa78$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $509076ff0c6afa78$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
const $509076ff0c6afa78$var$inputMediaDisabled = null;
const $509076ff0c6afa78$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $509076ff0c6afa78$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $509076ff0c6afa78$var$invalidStyle = null;
const $509076ff0c6afa78$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr3acm _195e18uv _bqhtnruj"
};
const $509076ff0c6afa78$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $509076ff0c6afa78$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _srjtgir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _srjtgir2"
};
const $509076ff0c6afa78$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $509076ff0c6afa78$var$getMaxWidth = (width)=>!width ? `100%` : width in $509076ff0c6afa78$var$widthMap ? `${$509076ff0c6afa78$var$widthMap[width]}px` : `${+width}px`;
const $509076ff0c6afa78$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $509076ff0c6afa78$var$containerStyles = null;
const $509076ff0c6afa78$var$inputDisabledStyle = null;
const $509076ff0c6afa78$var$inputCompactStyleWithFg = null;
const $509076ff0c6afa78$var$inputCompactStyle = null;
const $509076ff0c6afa78$var$inputMonospacedStyle = null;
const $509076ff0c6afa78$var$inputFontStyleWithFG = null;
const $509076ff0c6afa78$var$inputStyleMonospacedWithFg = null;
const $509076ff0c6afa78$var$inputStyleNotDataCompactWithFG = null;
const $509076ff0c6afa78$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $509076ff0c6afa78$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$509076ff0c6afa78$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $509076ff0c6afa78$var$getContainerTextBgAndBorderColor[appearance],
            $509076ff0c6afa78$var$containerStyleAppearance[appearance],
            !isDisabled && $509076ff0c6afa78$var$focusWithinStyle[appearance],
            !isDisabled && $509076ff0c6afa78$var$hoverStyle[appearance],
            isDisabled && $509076ff0c6afa78$var$containerMedia.disabled,
            isDisabled && $509076ff0c6afa78$var$disabledStyle[appearance],
            isInvalid && $509076ff0c6afa78$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _10j7r01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;

});

parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $26g7Y = parcelRequire("26g7Y");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $8CUq3.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $8CUq3.xcss)({
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});



parcelRegister("9dtoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be7444d19f2bd64$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $eZJjh = parcelRequire("eZJjh");
function $6be7444d19f2bd64$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6be7444d19f2bd64$var$LoadingWrapper, {
        height: props.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6be7444d19f2bd64$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i2nrh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gzFa5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b794bcef7eba373$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $YgTYj = parcelRequire("YgTYj");

var $dr63l = parcelRequire("dr63l");
class $7b794bcef7eba373$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    renderMenuListContent() {
        const { onBeforeLoading: onBeforeLoading, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dr63l.default), props);
    }
    renderError() {
        const { errorMessage: errorMessage, onRetry: onRetry } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YgTYj.default), {
            errorMessage: errorMessage,
            onRetry: onRetry
        });
    }
    render() {
        const { isError: isError } = this.props;
        return isError ? this.renderError() : this.renderMenuListContent();
    }
}

});
parcelRegister("YgTYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db5d1e5e2920327$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $az4zD = parcelRequire("az4zD");

var $k2Dsk = parcelRequire("k2Dsk");

var $4Ef54 = parcelRequire("4Ef54");
class $8db5d1e5e2920327$export$edf27be85e5f6da0 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { errorMessage: errorMessage, intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8db5d1e5e2920327$var$ErrorMessageParentContainer, {
            "data-test-id": "navigation-apps.common.compontents.switcher.switcher.menu-list.error.retry"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8db5d1e5e2920327$var$ErrorMessageContainer, null, errorMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: this.onClick
        }, formatMessage((0, $4Ef54.default).retry))));
    }
    constructor(...args){
        super(...args), this.onClick = (0, $k2Dsk.stopImmediatePropagation)(()=>this.props.onRetry());
    }
}
var $8db5d1e5e2920327$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($8db5d1e5e2920327$export$edf27be85e5f6da0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8db5d1e5e2920327$var$ErrorMessageParentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $8db5d1e5e2920327$var$ErrorMessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81vhk _1bto1l2s _syaz1fxt _otyru2gc _slp31hna _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Ef54", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccc38c6aa553a90$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8ccc38c6aa553a90$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "navigation-apps.common.compontents.switcher.switcher.menu-list.error.retry",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("dr63l", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd741accbf9449cb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
class $cd741accbf9449cb$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    renderListHeading() {
        const { listHeading: listHeading, options: options, isLoading: isLoading } = this.props;
        if (!listHeading || isLoading || !options || options.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd741accbf9449cb$var$ListHeadingWrapper, null, listHeading);
    }
    render() {
        const { listHeading: listHeading, children: children, ...props } = this.props;
        return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; isLoading: boolean; options: ItemGroup[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, this.renderListHeading(), children));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd741accbf9449cb$var$ListHeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _k48p1wq8 _1bto1l2s _ca0qutpp _u5f3utpp _n3tdu2gc _19bvutpp",
            __cmplp.className
        ])
    });
});

});


parcelRegister("15ZDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7ea467251319ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae7ea467251319ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    otherRecentBoards: {
        "id": "navigation-apps.switcher.other-recent-boards",
        "defaultMessage": "Other boards"
    }
});

});

parcelRegister("bv5KO", function(module, exports) {

$parcel$export(module.exports, "default", () => $722d8827e556040a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $60SKR = parcelRequire("60SKR");
const $722d8827e556040a$var$styles = {
    root: "_1tnqidpf _16hgr01l _btpdoahv _1w901fxt _18y1r01l _ksby1fxt _i9a11fxt",
    isFocused: "_16hg166n",
    isSelected: "_16hgfg4m _1w901e6v _ksby1e6v",
    isFocusedAndSelected: "_16hgi1yw",
    isViewAll: "_1w901e6v"
};
class $722d8827e556040a$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { data: data, isFocused: isFocused, isSelected: isSelected } = this.props;
        return /*#__PURE__*/ $5uXOq.createElement((0, $60SKR.Item), {
            ...data,
            component: this.renderComponent,
            // @ts-expect-error - TS2322 - Type '{ component: (props: { className: string; children: ReactNode; }) => Element; isFocused: boolean; isSelected: boolean; styles: (state: any) => { '&:focus': { backgroundColor: string; }; ... 5 more ...; height: string; }; ... 6 more ...; isDemo?: boolean | undefined; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
            isFocused: isFocused,
            isSelected: isSelected,
            className: (0, $bwpsq.default)([
                $722d8827e556040a$var$styles.root,
                isFocused && $722d8827e556040a$var$styles.isFocused,
                isSelected && $722d8827e556040a$var$styles.isSelected,
                isFocused && isSelected && $722d8827e556040a$var$styles.isFocusedAndSelected,
                data.isViewAll && $722d8827e556040a$var$styles.isViewAll
            ])
        });
    }
    constructor(...args){
        super(...args), this.onClick = (e)=>{
            if (e.ctrlKey || e.metaKey || e.button === 1) // if item was clicked with cmd or control or middle click -> simply open item in the new window
            return;
            e.preventDefault();
            if (this.props.innerProps && this.props.innerProps.onClick) this.props.innerProps.onClick();
        }, this.renderComponent = (props)=>{
            const { innerProps: innerProps, innerRef: innerRef, data: { url: url } } = this.props;
            return /*#__PURE__*/ $5uXOq.createElement("a", {
                ...innerProps,
                ref: innerRef,
                href: url,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: props.className,
                onClick: this.onClick
            }, props.children);
        };
    }
}

});


parcelRegister("dymxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d89767541e133d1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $c8Oei = parcelRequire("c8Oei");

var $60SKR = parcelRequire("60SKR");
const $5d89767541e133d1$var$styles = {
    root: "_1tnq1l7b _1wgmidpf _17bz1r31 _e0gcglyw _15451o36 _16hgr01l _1w901kw7 _12r21wq8 _1bk61b66 _davf1jma _u1mb1j9a _1fh11kw7 _ksby1kw7",
    isSelected: "_16hg1j9a _1w901e6v _1fh11e6v _ksby1e6v"
};
// @ts-expect-error - TS2769 - No overload matches this call.
const $5d89767541e133d1$var$renderChevron = ()=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        spacing: "spacious"
    });
class $5d89767541e133d1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isOpen: false,
            Icon: ()=>null,
            subText: '',
            targetRef: null,
            onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { isOpen: isOpen, text: text, subText: subText, onMouseEnter: onMouseEnter, targetRef: targetRef } = this.props;
        return /*#__PURE__*/ $5uXOq.createElement("div", null, /*#__PURE__*/ $5uXOq.createElement((0, $60SKR.Item), {
            component: this.renderComponent,
            text: text,
            subText: subText,
            before: this.props.Icon,
            after: $5d89767541e133d1$var$renderChevron,
            // @ts-expect-error - TS2322 - Type '{ component: (props: any) => Element; text: string; subText: string; before: ComponentType<any>; after: () => Element; isSelected: boolean; styles: (state: any) => any; onMouseEnter: () => void; targetRef: unknown; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
            isSelected: isOpen,
            onMouseEnter: onMouseEnter,
            targetRef: targetRef,
            className: (0, $bwpsq.default)([
                $5d89767541e133d1$var$styles.root,
                isOpen && $5d89767541e133d1$var$styles.isSelected
            ])
        }));
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("button", {
                ref: props.targetRef,
                "aria-expanded": this.props.isOpen,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: props.className,
                onMouseEnter: props.onMouseEnter,
                id: "navigation-apps.scope-switcher-trigger-button"
            }, props.children);
    }
}

});

parcelRegister("8aG9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fed20b40146a444$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1fed20b40146a444$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    labelBoardsInProjectLocation: {
        "id": "navigation-apps.scope-switcher-v2.label-boards-in-project-location",
        "defaultMessage": "Boards in {locationName}"
    },
    labelBoardsInUserLocationNew: {
        "id": "navigation-apps.scope-switcher-v2.label-boards-in-user-location-new",
        "defaultMessage": "{locationName}''{lastLetter, select, s {} z {} other {s}} boards"
    },
    otherRecentBoards: {
        "id": "navigation-apps.scope-switcher-v2.other-recent-boards",
        "defaultMessage": "Other boards"
    },
    createBoard: {
        "id": "navigation-apps.scope-switcher-v2.create-board",
        "defaultMessage": "Create board"
    },
    board: {
        "id": "navigation-apps.scope-switcher-v2.board",
        "defaultMessage": "Board"
    },
    boards: {
        "id": "navigation-apps.scope-switcher-v2.boards",
        "defaultMessage": "Boards"
    },
    locationDoesNotHaveBoard: {
        "id": "navigation-apps.scope-switcher-v2.location-does-not-have-board",
        "defaultMessage": "{location} doesn't have a board"
    },
    projectLocationDescription: {
        "id": "navigation-apps.scope-switcher-v2.project-location-description",
        "defaultMessage": "in {location}"
    },
    userLocationDescriptionNew: {
        "id": "navigation-apps.scope-switcher-v2.user-location-description-new",
        "defaultMessage": "{locationName}''{lastLetter, select, s {} z {} other {s}}"
    },
    viewAllBoards: {
        "id": "navigation-apps.scope-switcher-v2.view-all-boards",
        "defaultMessage": "View all boards"
    },
    viewAll: {
        "id": "navigation-apps.scope-switcher-v2.view-all",
        "defaultMessage": "View all"
    },
    searchPlaceholder: {
        "id": "navigation-apps.scope-switcher-v2.search-placeholder",
        "defaultMessage": "Search for boards\u2026"
    },
    searchBoardsInLocationLabel: {
        "id": "navigation-apps.scope-switcher-v2.search-boards-in-location-label",
        "defaultMessage": "Boards in {locationName}"
    },
    searchBoardsNotInLocationLabel: {
        "id": "navigation-apps.scope-switcher-v2.search-boards-not-in-location-label",
        "defaultMessage": "Other boards"
    },
    searchNoMatchesFound: {
        "id": "navigation-apps.scope-switcher-v2.search-no-matches-found",
        "defaultMessage": "No results"
    },
    errorMessage: {
        "id": "navigation-apps.scope-switcher-v2.error-message",
        "defaultMessage": "We're having troubles connecting to your boards"
    },
    showMore: {
        "id": "navigation-apps.scope-switcher-v2.show-more",
        "defaultMessage": "Show { remainingBoards } more"
    }
});

});




parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});




parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});


parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("bdAP2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9902567d9e017eb1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9902567d9e017eb1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    board: {
        "id": "spa-apps-sidebar-common.scope-switcher.board",
        "defaultMessage": "Board"
    }
});

});


parcelRegister("3SzZi", function(module, exports) {

$parcel$export(module.exports, "shouldRenderNesting", () => $956cef61e43b05f1$export$a35baff1c4efd3da);
const $956cef61e43b05f1$export$a35baff1c4efd3da = (condition, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));

});

parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("4OCke", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $cf3ce1d2a79b8e17$export$63fdecce99465869);

var $f8l56 = parcelRequire("f8l56");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

const $2abca4e721f0f565$export$d4cd258d01c03112 = 'user';

parcelRegister("lUN4t", function(module, exports) {

$parcel$export(module.exports, "useAvatar", () => $adaea94b71849806$export$e81fcf1d7807b0c);

var $5uXOq = parcelRequire("5uXOq");

var $gpXo6 = parcelRequire("gpXo6");
const $adaea94b71849806$var$extractData = (navData)=>({
        name: navData.owner.name,
        url: navData.owner.avatarUrl
    });
const $adaea94b71849806$export$e81fcf1d7807b0c = ()=>{
    const { data: data, loading: loading, error: error } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data ? $adaea94b71849806$var$extractData(data) : null, [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});

parcelRegister("l0NCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7cb092c9bfa57e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bb7cb092c9bfa57e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlog: {
        "id": "spa-apps-sidebar-user.menu.backlog",
        "defaultMessage": "Backlog"
    },
    headerDescription: {
        "id": "spa-apps-sidebar-user.menu.header-description",
        "defaultMessage": "Boards"
    },
    itemBack: {
        "id": "spa-apps-sidebar-user.menu.item-back",
        "defaultMessage": "Back"
    },
    itemReports: {
        "id": "spa-apps-sidebar-user.menu.item-reports",
        "defaultMessage": "Reports"
    },
    kanbanBoard: {
        "id": "spa-apps-sidebar-user.menu.kanban-board",
        "defaultMessage": "Kanban board"
    },
    scrumBoard: {
        "id": "spa-apps-sidebar-user.menu.scrum-board",
        "defaultMessage": "Active sprints"
    }
});

});

parcelRegister("b0U9q", function(module, exports) {

$parcel$export(module.exports, "Reports", () => $f4b09300f47bce79$export$883262dc952d8f59);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fNi03 = parcelRequire("fNi03");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $8CVvd = parcelRequire("8CVvd");

var $9hLEH = parcelRequire("9hLEH");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");

var $1xIfX = parcelRequire("1xIfX");

var $gSoiq = parcelRequire("gSoiq");
const $f4b09300f47bce79$var$useThrowReports = (0, $7OqB4.withThrowOnError)((0, $1xIfX.useReports));
const $f4b09300f47bce79$var$useThrowBoard = (0, $7OqB4.withThrowOnError)((0, $fNi03.useBoard));
const $f4b09300f47bce79$export$883262dc952d8f59 = ({ enableKeyboardShortcuts: enableKeyboardShortcuts })=>{
    const [paramAccountId] = (0, $bmKPg.usePathParam)('accountId');
    const [isLocationlessBoard] = (0, $ieDtd.useQueryParam)('locationless');
    const { data: board } = $f4b09300f47bce79$var$useThrowBoard();
    const { data: reports } = $f4b09300f47bce79$var$useThrowReports();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (board == null || reports == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const boardAccountId = paramAccountId ?? '';
    const shouldUsePrettyUrl = !isLocationlessBoard;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $gSoiq.default).reports)
    }, (0, $4R6GH.fg)('reports-overview-page-migration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'all-reports'
        },
        href: `/jira/people/${boardAccountId}/boards/${board.id}/reports`,
        key: "all-reports",
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $gSoiq.default).allReports)), reports.map(({ chart: chart, id: id, message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: `report-${id}`
            },
            href: shouldUsePrettyUrl ? `/jira/people/${boardAccountId}/boards/${board.id}/reports/${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(chart)}` : `/secure/RapidBoard.jspa?rapidView=${board.id}&view=reporting&chart=${chart}&locationless=true`,
            key: id,
            selectedOn: shouldUsePrettyUrl ? (0, $4OCke.matchUrlPathname)() : ({ query: query })=>query.chart === chart
        }, formatMessage(message))), enableKeyboardShortcuts && !isLocationlessBoard && (0, $8CVvd.getWillShowNav3)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hLEH.default), {
        boardId: board.id,
        projectKey: ""
    }) : null);
};

});
parcelRegister("9hLEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25af9d0222a23099$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25af9d0222a23099$var$LazyProjectKeyboardShortcuts = (0, $kxZPA.lazy)(()=>(parcelRequire("8pp6L")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $25af9d0222a23099$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25af9d0222a23099$var$LazyProjectKeyboardShortcuts, props)));
var $25af9d0222a23099$export$2e2bcd8739ae039 = $25af9d0222a23099$var$ProjectKeyboardShortcuts;

});
parcelRegister("8pp6L", function(module, exports) {

let $61f42276bdabf6ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $61f42276bdabf6ca$var$load("cM9em"),
    $61f42276bdabf6ca$var$load("fr9NE"),
    $61f42276bdabf6ca$var$load("3gkNR")
]).then(()=>parcelRequire('9pQJj'));

});


parcelRegister("1xIfX", function(module, exports) {

$parcel$export(module.exports, "useReports", () => $772ccaca2acf218e$export$fa3120960baf4ea2);

var $5uXOq = parcelRequire("5uXOq");

var $gpXo6 = parcelRequire("gpXo6");

var $3Rfpd = parcelRequire("3Rfpd");
const $772ccaca2acf218e$export$fa3120960baf4ea2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data ? (0, $3Rfpd.extractData)(data.boardInfo) : null, [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("3Rfpd", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $0a30da5663aab212$export$9df5fa0a366163d2);


var $5yiGG = parcelRequire("5yiGG");
const $0a30da5663aab212$var$reports = [
    {
        chart: 'burndownChart',
        id: 'agile-burndown-chart',
        message: (0, $5yiGG.default).burndown,
        scrumOnly: true
    },
    {
        chart: 'burnupChart',
        id: 'agile-burnup-chart',
        message: (0, $5yiGG.default).burnup,
        scrumOnly: true
    },
    {
        chart: 'sprintRetrospective',
        id: 'agile-sprint-retrospective',
        message: (0, $5yiGG.default).sprint,
        scrumOnly: true
    },
    {
        chart: 'velocity',
        id: 'agile-velocity-chart',
        message: (0, $5yiGG.default).velocity,
        scrumOnly: true
    },
    {
        chart: 'cumulativeFlowDiagram',
        id: 'agile-cumulative-flow-diagram',
        message: (0, $5yiGG.default).flow,
        scrumOnly: false
    },
    {
        chart: 'versionReport',
        id: 'agile-version-report',
        message: (0, $5yiGG.default).version,
        scrumOnly: true
    },
    {
        chart: 'epicReport',
        id: 'agile-epic-report',
        message: (0, $5yiGG.default).epic,
        scrumOnly: true
    },
    {
        chart: 'controlChart',
        id: 'agile-control-chart',
        message: (0, $5yiGG.default).control,
        scrumOnly: false
    },
    {
        chart: 'epicBurndown',
        id: 'agile-epic-burndown',
        message: (0, $5yiGG.default).epicBurndown,
        scrumOnly: true
    },
    {
        chart: 'releaseBurndown',
        id: 'agile-release-burndown',
        message: (0, $5yiGG.default).releaseBurndown,
        scrumOnly: true
    }
];
const $0a30da5663aab212$export$9df5fa0a366163d2 = (board)=>{
    const isScrum = board.type === (0, $976eff6d67d3515b$export$4498412e32a31fb6);
    return $0a30da5663aab212$var$reports.filter(({ scrumOnly: scrumOnly })=>scrumOnly ? isScrum : true);
};

});
parcelRegister("5yiGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $962f5430bbcf4f24$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $962f5430bbcf4f24$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    burndown: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.burndown",
        "defaultMessage": "Burndown Chart"
    },
    burnup: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.burnup",
        "defaultMessage": "Burnup Chart"
    },
    sprint: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.sprint",
        "defaultMessage": "Sprint Report"
    },
    velocity: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.velocity",
        "defaultMessage": "Velocity Chart"
    },
    flow: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.flow",
        "defaultMessage": "Cumulative Flow Diagram"
    },
    version: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.version",
        "defaultMessage": "Version Report"
    },
    epic: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.epic",
        "defaultMessage": "Epic Report"
    },
    control: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.control",
        "defaultMessage": "Control Chart"
    },
    epicBurndown: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.epic-burndown",
        "defaultMessage": "Epic Burndown"
    },
    releaseBurndown: {
        "id": "spa-apps-sidebar-user.controllers.reports.utils.release-burndown",
        "defaultMessage": "Release Burndown"
    }
});

});



parcelRegister("gSoiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd680bcf5e6c78a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dbd680bcf5e6c78a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reports: {
        "id": "spa-apps-sidebar-user.menu.reports.reports",
        "defaultMessage": "Reports"
    },
    allReports: {
        "id": "spa-apps-sidebar-user.menu.reports.all-reports",
        "defaultMessage": "All reports"
    }
});

});


parcelRegister("2f44y", function(module, exports) {

$parcel$export(module.exports, "backlogSelected", () => $fccf3e1a7bbe6b6f$export$db1526e14c4a35fc);
$parcel$export(module.exports, "boardSelected", () => $fccf3e1a7bbe6b6f$export$d7c31c2a3f8bc9fa);
$parcel$export(module.exports, "calculateStack", () => $fccf3e1a7bbe6b6f$export$b753dc61ba067fb);

var $4R6GH = parcelRequire("4R6GH");

var $4OCke = parcelRequire("4OCke");
const $fccf3e1a7bbe6b6f$export$db1526e14c4a35fc = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlParams)([
        'rapidView'
    ])(currentLocation, itemLocation) && (currentLocation.query.view ?? '').includes('planning');
const $fccf3e1a7bbe6b6f$export$d7c31c2a3f8bc9fa = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlParams)([
        'rapidView'
    ])(currentLocation, itemLocation) && !currentLocation.query.useStoredSettings && !currentLocation.query.view;
const $fccf3e1a7bbe6b6f$export$b753dc61ba067fb = (route)=>route?.name === 'rapidboard-report' || route?.name === 'rapidboard-user-report' || [
        'rapidboard-user-reports-overview',
        'software-reports-velocity-user-board'
    ].includes(route?.name ?? '') && (0, $4R6GH.fg)('reports-overview-page-migration') ? [
        'reports'
    ] : [];

});





//# sourceMappingURL=async-sidebar-user.cd6a2e22.js.map
